export function VIFMulDiv(cjs, an) {
  var p; // shortcut to reference prototypes
  var lib = {};
  var ss = {};
  var img = {};
  lib.ssMetadata = [];

  (lib.AnMovieClip = function () {
    this.actionFrames = [];
    this.ignorePause = false;
    this.gotoAndPlay = function (positionOrLabel) {
      cjs.MovieClip.prototype.gotoAndPlay.call(this, positionOrLabel);
    };
    this.play = function () {
      cjs.MovieClip.prototype.play.call(this);
    };
    this.gotoAndStop = function (positionOrLabel) {
      cjs.MovieClip.prototype.gotoAndStop.call(this, positionOrLabel);
    };
    this.stop = function () {
      cjs.MovieClip.prototype.stop.call(this);
    };
  }).prototype = p = new cjs.MovieClip();
  // symbols:
  // helper functions:

  function mc_symbol_clone() {
    var clone = this._cloneProps(
      new this.constructor(
        this.mode,
        this.startPosition,
        this.loop,
        this.reversed,
      ),
    );
    clone.gotoAndStop(this.currentFrame);
    clone.paused = this.paused;
    clone.framerate = this.framerate;
    return clone;
  }

  function getMCSymbolPrototype(symbol, nominalBounds, frameBounds) {
    var prototype = cjs.extend(symbol, cjs.MovieClip);
    prototype.clone = mc_symbol_clone;
    prototype.nominalBounds = nominalBounds;
    prototype.frameBounds = frameBounds;
    return prototype;
  }

  (lib.ValueTextBlack_line = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(2));

    // Layer 1
    this.shape = new cjs.Shape();
    this.shape.graphics.f().s('#000000').ss(2, 0, 1).p('AifAAIE/AA');

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics.f().s('#FFFFFF').ss(2, 0, 1).p('AihAAIFDAA');
    this.shape_1.setTransform(0.025, 0);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape }] })
        .to({ state: [{ t: this.shape_1 }] }, 1)
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-17.1, -1, 34.3, 2);

  (lib.ValueText_glow = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 1
    this.shape = new cjs.Shape();
    this.shape.graphics
      .rf(
        [
          'rgba(255,255,255,0.502)',
          'rgba(255,255,255,0.8)',
          'rgba(255,255,255,0)',
        ],
        [0, 0, 1],
        0,
        0,
        0,
        0,
        0,
        20.8,
      )
      .s()
      .p(
        'AiRCSQg9g8ABhWQgBhVA9g8QA8g9BVAAQBVAAA9A9QA9A8gBBVQABBWg9A8Qg9A9hVAAQhVAAg8g9g',
      );
    this.shape.setTransform(0.0184, -0.0236, 1.4528, 1.4492);

    this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.ValueText_glow,
    new cjs.Rectangle(-30, -30, 60, 60),
    null,
  );

  (lib.comsuntexsymbolsValueText = function (
    mode,
    startPosition,
    loop,
    reversed,
  ) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 1
    this.smallText = new cjs.Text('1', "bold 16px 'Tahoma'");
    this.smallText.name = 'smallText';
    this.smallText.textAlign = 'center';
    this.smallText.lineHeight = 13;
    this.smallText.lineWidth = 57;
    this.smallText.parent = this;
    this.smallText.setTransform(17.65, 2);

    this.timeline.addTween(cjs.Tween.get(this.smallText).wait(1));

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.comsuntexsymbolsValueText,
    new cjs.Rectangle(-13, 0, 61.3, 25.8),
    null,
  );

  (lib.OperationButtons = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(4));

    // icon
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f()
      .s('#666666')
      .ss(1, 1, 1)
      .p('AAxgwIBqAAAiaAxIAAhhIBqAAIAAhqIBhAAAgwCbIAAhq');
    this.shape.setTransform(-0.05, 0);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f()
      .s('#CCCCCC')
      .ss(1, 1, 1)
      .p('AAxiaIAABqACbgwIAABhIhqAAIAABqIhhAAAgwAxIhqAA');
    this.shape_1.setTransform(-0.05, 0);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('rgba(255,255,255,0.8)')
      .s()
      .p('AgvCbIAAhqIhrAAIAAhhIBrAAIAAhqIBgAAIAABqIBqAAIAABhIhqAAIAABqg');
    this.shape_2.setTransform(-0.05, 0);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics.f().s('#666666').ss(1, 1, 1).p('AiaAxIAAhhIE1AA');
    this.shape_3.setTransform(-0.05, 0.025);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics.f().s('#CCCCCC').ss(1, 1, 1).p('ACbgwIAABhIk1AA');
    this.shape_4.setTransform(-0.05, 0.025);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f('rgba(255,255,255,0.8)')
      .s()
      .p('AiaAxIAAhhIE1AAIAABhg');
    this.shape_5.setTransform(-0.05, 0.025);

    this.shape_6 = new cjs.Shape();
    this.shape_6.graphics
      .f()
      .s('#CCCCCC')
      .ss(1, 1, 1)
      .p('ACQApIhFBFIhLhLIhKBLIhFhFAhEgiIhLhLACQhtIhLBL');
    this.shape_6.setTransform(0.05, 3.5);

    this.shape_7 = new cjs.Shape();
    this.shape_7.graphics
      .f()
      .s('#666666')
      .ss(1, 1, 1)
      .p('AiPgoIBFhFIBKBLIBLhLIBFBFAiPBuIBLhMABFAiIBLBM');
    this.shape_7.setTransform(0.05, -3.4);

    this.shape_8 = new cjs.Shape();
    this.shape_8.graphics
      .f('rgba(255,255,255,0.8)')
      .s()
      .p('AAABFIhKBLIhFhFIBLhLIhLhKIBFhFIBKBLIBLhLIBFBFIhLBKIBLBLIhFBFg');
    this.shape_8.setTransform(0.05, 0.05);

    this.shape_9 = new cjs.Shape();
    this.shape_9.graphics
      .f()
      .s('#666666')
      .ss(1, 1, 1)
      .p(
        'AgZhPQgDgEgDgDQgJgOACgPQADgQAOgJQAMgJAPADQAIABAMAHAgZCUQgDgEgDgDQgJgOACgPQADgQAOgJQAMgJAPADQAIABALAGAiaA1IAAhhIE1AA',
      );
    this.shape_9.setTransform(0, -0.436);

    this.shape_10 = new cjs.Shape();
    this.shape_10.graphics
      .f()
      .s('#CCCCCC')
      .ss(1, 1, 1)
      .p(
        'AAeiQQADAFACAFQADAKgCAKQgCAKgFAHQgDAEgFAEQgNAJgPgDQgHgBgFgDAAdBTQAKAOgDAQQgCAPgNAKQgNAJgPgDQgHgBgFgDACbg4IAABhIk1AA',
      );
    this.shape_10.setTransform(0, 0.761);

    this.shape_11 = new cjs.Shape();
    this.shape_11.graphics
      .f('rgba(255,255,255,0.8)')
      .s()
      .p(
        'AgGCYIgNgEIgFgFIgHgHQgJgNACgPQADgQAOgJQAMgJAPACQAIABAKAHIAFAGQAKAPgDAQQgCAPgNAJQgKAHgLAAIgGAAgAiaAwIAAhgIE1AAIAABggAgGhLQgIgCgFgDIgFgEIgHgHQgJgNACgQQADgPAOgJQAMgKAPADQAIABALAIIAFAFIAFAKQADAKgCAKQgCAKgFAHQgDAFgFADQgLAHgKAAIgGAAg',
      );
    this.shape_11.setTransform(0, 0.025);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [{ t: this.shape_2 }, { t: this.shape_1 }, { t: this.shape }],
        })
        .to(
          {
            state: [
              { t: this.shape_5 },
              { t: this.shape_4 },
              { t: this.shape_3 },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_8 },
              { t: this.shape_7 },
              { t: this.shape_6 },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_11 },
              { t: this.shape_10 },
              { t: this.shape_9 },
            ],
          },
          1,
        )
        .wait(1),
    );

    // color
    this.shape_12 = new cjs.Shape();
    this.shape_12.graphics
      .rf(['#A415EA', '#541D67'], [0, 1], -1.9, -8.5, 0, -1.9, -8.5, 40.1)
      .s()
      .p(
        'AiODMQhVg7gRhmQgThlA7hVQA7hUBngSQBkgRBVA7QBVA7ASBmQASBlg8BUQg7BUhlATQgYAEgWAAQhLAAhBgug',
      );
    this.shape_12.setTransform(-0.0061, 0.0189);

    this.shape_13 = new cjs.Shape();
    this.shape_13.graphics
      .rf(['#1BB448', '#265945'], [0, 1], -1.9, -8.4, 0, -1.9, -8.4, 40)
      .s()
      .p(
        'AiODNQhVg8gShmQgShlA7hUQA8hUBmgTQBkgRBVA7QBUA7ATBmQASBlg8BUQg7BVhmASQgXAEgWAAQhLAAhBgtg',
      );
    this.shape_13.setTransform(0.0146, -0.0135);

    this.shape_14 = new cjs.Shape();
    this.shape_14.graphics
      .rf(['#351DE2', '#2C2659'], [0, 1], -1.9, -8.6, 0, -1.9, -8.6, 40.1)
      .s()
      .p(
        'AiODMQhVg7gShmQgShlA7hUQA8hWBmgRQBkgSBVA8QBUA7ATBmQARBlg7BUQg8BVhlASQgYAEgWAAQhLAAhAgug',
      );
    this.shape_14.setTransform(0.0045, 0);

    this.shape_15 = new cjs.Shape();
    this.shape_15.graphics
      .rf(['#FF0000', '#990000'], [0, 1], -1.8, -8.5, 0, -1.8, -8.5, 40.1)
      .s()
      .p(
        'AiODMQhVg7gShmQgShlA8hVQA7hUBmgSQBkgSBVA8QBUA7ATBmQASBlg8BUQg7BUhlATQgYAEgVAAQhMAAhBgug',
      );
    this.shape_15.setTransform(-0.0102, 0.0013);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_12 }] })
        .to({ state: [{ t: this.shape_13 }] }, 1)
        .to({ state: [{ t: this.shape_14 }] }, 1)
        .to({ state: [{ t: this.shape_15 }] }, 1)
        .wait(1),
    );

    // shine
    this.shape_16 = new cjs.Shape();
    this.shape_16.graphics
      .lf(
        ['rgba(255,255,255,0.502)', 'rgba(255,255,255,0)'],
        [0, 0.682],
        0,
        -19.1,
        0,
        19.2,
      )
      .s()
      .p(
        'AiHCHQg4g3AAhQQAAhPA4g4QA5g3BOAAQBPAAA5A3QA4A4AABPQAABQg4A3Qg5A4hPAAQhOAAg5g4g',
      );
    this.shape_16.setTransform(0.15, -2.3);

    this.timeline.addTween(cjs.Tween.get(this.shape_16).wait(4));

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-25, -25, 50, 50);

  (lib.verticalMeter = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };
    this.frame_2 = function () {
      this.stop();
    };
    this.frame_3 = function () {
      this.stop();
    };
    this.frame_4 = function () {
      this.stop();
    };
    this.frame_5 = function () {
      this.stop();
    };
    this.frame_6 = function () {
      this.stop();
    };
    this.frame_7 = function () {
      this.stop();
    };
    this.frame_8 = function () {
      this.stop();
    };
    this.frame_9 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this)
        .call(this.frame_0)
        .wait(1)
        .call(this.frame_1)
        .wait(1)
        .call(this.frame_2)
        .wait(1)
        .call(this.frame_3)
        .wait(1)
        .call(this.frame_4)
        .wait(1)
        .call(this.frame_5)
        .wait(1)
        .call(this.frame_6)
        .wait(1)
        .call(this.frame_7)
        .wait(1)
        .call(this.frame_8)
        .wait(1)
        .call(this.frame_9)
        .wait(1),
    );

    // Layer 3
    this.shape = new cjs.Shape();
    this.shape.graphics.f().s('#7AA8F9').ss(1, 1, 1).p('Ah8gRID5AAIAAAjIj5AAg');
    this.shape.setTransform(16.5, 139.6);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics.f('#7AA8F9').s().p('Ah8ARIAAgiID5AAIAAAig');
    this.shape_1.setTransform(16.5, 139.6);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f()
      .s('#7AA8F9')
      .ss(1, 1, 1)
      .p('Ah8gLID5AAIAAAXIj5AAg');
    this.shape_2.setTransform(16.5, 210.05);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics.f('#7AA8F9').s().p('Ah8AMIAAgXID5AAIAAAXg');
    this.shape_3.setTransform(16.5, 210.05);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .f()
      .s('#7AA8F9')
      .ss(1, 1, 1)
      .p('Ah8gRID5AAIAAAjIj5AAg');
    this.shape_4.setTransform(16.5, 69);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics.f('#7AA8F9').s().p('Ah8ARIAAgiID5AAIAAAig');
    this.shape_5.setTransform(16.5, 69);

    this.shape_6 = new cjs.Shape();
    this.shape_6.graphics
      .f()
      .s('#FFFFFF')
      .ss(1, 1, 1)
      .p(
        'AiG2AIENAAIAAK8IkNAAgAiGq/IENAAIAAK8IkNAAgAiGAEIENAAIAAK8IkNAAgAiGLFIENAAIAAK8IkNAAg',
      );
    this.shape_6.setTransform(16.5, 139.85);

    this.shape_7 = new cjs.Shape();
    this.shape_7.graphics
      .f('#7AA8F9')
      .s()
      .p(
        'AiGWBIAAq8IENAAIAAK8gAiGLAIAAq8IENAAIAAK8gAiGgDIAAq8IENAAIAAK8gAiGrEIAAq7IENAAIAAK7g',
      );
    this.shape_7.setTransform(16.5, 139.85);

    this.shape_8 = new cjs.Shape();
    this.shape_8.graphics
      .f()
      .s('#BBE42E')
      .ss(1, 1, 1)
      .p('Ah8gRID5AAIAAAjIj5AAg');
    this.shape_8.setTransform(16.5, 139.6);

    this.shape_9 = new cjs.Shape();
    this.shape_9.graphics.f('#BBE42E').s().p('Ah8ARIAAgiID5AAIAAAig');
    this.shape_9.setTransform(16.5, 139.6);

    this.shape_10 = new cjs.Shape();
    this.shape_10.graphics
      .f()
      .s('#BBE42E')
      .ss(1, 1, 1)
      .p('Ah8gLID5AAIAAAXIj5AAg');
    this.shape_10.setTransform(16.5, 210.05);

    this.shape_11 = new cjs.Shape();
    this.shape_11.graphics.f('#BBE42E').s().p('Ah8AMIAAgXID5AAIAAAXg');
    this.shape_11.setTransform(16.5, 210.05);

    this.shape_12 = new cjs.Shape();
    this.shape_12.graphics
      .f()
      .s('#BBE42E')
      .ss(1, 1, 1)
      .p('Ah8gRID5AAIAAAjIj5AAg');
    this.shape_12.setTransform(16.5, 69);

    this.shape_13 = new cjs.Shape();
    this.shape_13.graphics.f('#BBE42E').s().p('Ah8ARIAAgiID5AAIAAAig');
    this.shape_13.setTransform(16.5, 69);

    this.shape_14 = new cjs.Shape();
    this.shape_14.graphics
      .f('#BBE42E')
      .s()
      .p(
        'AiGWBIAAq8IENAAIAAK8gAiGLAIAAq8IENAAIAAK8gAiGgDIAAq8IENAAIAAK8gAiGrEIAAq7IENAAIAAK7g',
      );
    this.shape_14.setTransform(16.5, 139.85);

    this.shape_15 = new cjs.Shape();
    this.shape_15.graphics.f('#BBE42E').s().p('AiGFeIAAq7IENAAIAAK7g');
    this.shape_15.setTransform(16.5, 245.725);

    this.shape_16 = new cjs.Shape();
    this.shape_16.graphics
      .f('#7AA8F9')
      .s()
      .p('AiGQgIAAq8IENAAIAAK8gAiGFcIAAq6IENAAIAAK6gAiGlkIAAq7IENAAIAAK7g');
    this.shape_16.setTransform(16.5, 104.6);

    this.shape_17 = new cjs.Shape();
    this.shape_17.graphics
      .f('#BBE42E')
      .s()
      .p('AiGK+IAAq7IENAAIAAK7gAiGgCIAAq7IENAAIAAK7g');
    this.shape_17.setTransform(16.5, 210.475);

    this.shape_18 = new cjs.Shape();
    this.shape_18.graphics
      .f('#7AA8F9')
      .s()
      .p('AiGK+IAAq7IENAAIAAK7gAiGgCIAAq7IENAAIAAK7g');
    this.shape_18.setTransform(16.5, 69.225);

    this.shape_19 = new cjs.Shape();
    this.shape_19.graphics
      .f('#BBE42E')
      .s()
      .p('AiGQgIAAq7IENAAIAAK7gAiGFfIAAq7IENAAIAAK7gAiGlkIAAq7IENAAIAAK7g');
    this.shape_19.setTransform(16.5, 175.1);

    this.shape_20 = new cjs.Shape();
    this.shape_20.graphics.f('#7AA8F9').s().p('AiGFeIAAq7IENAAIAAK7g');
    this.shape_20.setTransform(16.5, 33.975);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.shape_7 },
            { t: this.shape_6 },
            { t: this.shape_5 },
            { t: this.shape_4 },
            { t: this.shape_3 },
            { t: this.shape_2 },
            { t: this.shape_1, p: { y: 139.6 } },
            { t: this.shape, p: { y: 139.6 } },
          ],
        })
        .to(
          {
            state: [
              { t: this.shape_14 },
              { t: this.shape_6 },
              { t: this.shape_13 },
              { t: this.shape_12 },
              { t: this.shape_11 },
              { t: this.shape_10 },
              { t: this.shape_9, p: { y: 139.6 } },
              { t: this.shape_8, p: { y: 139.6 } },
            ],
          },
          1,
        )
        .to({ state: [{ t: this.shape_7 }, { t: this.shape_6 }] }, 1)
        .to(
          {
            state: [
              { t: this.shape_16 },
              { t: this.shape_15 },
              { t: this.shape_6 },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_18 },
              { t: this.shape_17 },
              { t: this.shape_6 },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_20 },
              { t: this.shape_19 },
              { t: this.shape_6 },
            ],
          },
          1,
        )
        .to({ state: [{ t: this.shape_14 }, { t: this.shape_6 }] }, 1)
        .to(
          {
            state: [
              { t: this.shape_7 },
              { t: this.shape_6 },
              { t: this.shape_1, p: { y: 69 } },
              { t: this.shape, p: { y: 69 } },
              { t: this.shape_3 },
              { t: this.shape_2 },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_18 },
              { t: this.shape_17 },
              { t: this.shape_6 },
              { t: this.shape_1, p: { y: 69 } },
              { t: this.shape, p: { y: 69 } },
              { t: this.shape_11 },
              { t: this.shape_10 },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_14 },
              { t: this.shape_6 },
              { t: this.shape_9, p: { y: 69 } },
              { t: this.shape_8, p: { y: 69 } },
              { t: this.shape_11 },
              { t: this.shape_10 },
            ],
          },
          1,
        )
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(2, -2, 29, 283.7);

  (lib.blocker = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 1
    this.shape = new cjs.Shape();
    this.shape.graphics.f('#CCCCCC').s().p('AuDK8IAA13IcHAAIAAV3g');
    this.shape.setTransform(90, 70);

    this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.blocker,
    new cjs.Rectangle(0, 0, 180, 140),
    null,
  );

  (lib.Scoreboard_progressMeter_fill = function (
    mode,
    startPosition,
    loop,
    reversed,
  ) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 1
    this.shape = new cjs.Shape();
    this.shape.graphics.f('#FFFF00').s().p('AvnCWIAAkrIfPAAIAAErg');
    this.shape.setTransform(100, 0);

    this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.Scoreboard_progressMeter_fill,
    new cjs.Rectangle(0, -15, 200, 30),
    null,
  );

  (lib.Scoreboard_changeRoundBtn = function (
    mode,
    startPosition,
    loop,
    reversed,
  ) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 1
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AgRAhIgKgEIAAgRIABAAIAEACIAFADIAGADIAIABQAEAAADgCQADgBAAgDQAAgBAAAAQAAgBAAAAQAAgBgBAAQAAAAAAgBIgGgCIgFgBIgGgCQgIgCgEgEQgEgEAAgIQAAgFACgDQACgEAEgDQAEgDAGgCQAFgCAHAAQAHAAAFACQAGABAEACIAAAQIgBAAIgEgCIgEgCIgGgCIgHgBQgDAAgDACQgBAAgBABQAAAAAAABQgBAAAAABQAAAAAAABQAAAAAAABQAAAAAAABQAAAAABAAQAAABAAAAQACACAEABIAGABIAHACQAHACADADQAEAFAAAHQAAAFgCAEQgCAEgEADQgEADgGACQgGACgHAAQgHAAgHgCg',
      );
    this.shape.setTransform(19.525, 9.825);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AgZAlQgGgJAAgQQAAgJACgFQACgGAEgFQAEgEAFgDQAFgCAGAAIAHABIAIAEIAAgdIAUAAIAABbIgUAAIAAgHIgFADIgEADIgEACIgGABQgLAAgHgKgAgGgCQgEAFAAAJQAAAKADAEQADAEAFAAQADAAADgBIAFgCIAAggIgEgBIgEAAQgHAAgDAEg',
      );
    this.shape_1.setTransform(12.325, 8.65);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AAKAiIAAghIAAgHIgBgGIgDgDIgGgBIgEABIgFADIAAAuIgVAAIAAhBIAVAAIAAAHQAFgEAEgCQAEgDAGAAQAKAAAFAHQAGAGAAAMIAAAqg',
      );
    this.shape_2.setTransform(4.975, 9.725);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AgYAcQgGgHAAgMIAAgqIAVAAIAAAhIAAAHIABAGIADACQACACADAAIAFgCIAFgCIAAguIAVAAIAABBIgVAAIAAgIIgKAIQgDACgGAAQgKAAgFgGg',
      );
    this.shape_3.setTransform(-2.775, 9.9);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AgYAZQgJgIAAgRQAAgQAJgIQAJgKAPAAQAQAAAJAKQAJAJAAAPQAAARgJAIQgIAKgRAAQgPAAgJgKgAgEgTIgEAEQgCACgBAEIgBAJIABAKIACAGIAFAEIAEABIAFgBIAEgEIADgGIABgKIgBgJIgDgFQgCgDgCgBIgFgBIgEAAg',
      );
    this.shape_4.setTransform(-10.3, 9.8);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AAOAsIgYghIgHAAIAAAhIgWAAIAAhWIAjAAIAMAAQAFABAEADQAFADADAEQADAFAAAHQAAAKgFAGQgEAGgIADIAdAmgAgRgDIAGAAIAIgBIAEgCIADgEIABgGQAAgEgBgCQgBgCgDgBIgEgBIgGAAIgHAAg',
      );
    this.shape_5.setTransform(-17.775, 8.75);

    this.shape_6 = new cjs.Shape();
    this.shape_6.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AgWAaQgKgJAAgRQAAgOAKgKQAJgKAPAAQAQAAAHAIQAIAJAAAPIAAAGIgsAAIACAIQABADADABQADACACABIAIABIAHgBIAGgCIAFgCIADgCIADAAIAAARIgFABIgGACIgHABIgIABQgSAAgKgJgAgHgRQgEAEAAAFIAYAAQgBgGgCgEQgDgCgGAAQgFAAgDADg',
      );
    this.shape_6.setTransform(19.025, -4.7);

    this.shape_7 = new cjs.Shape();
    this.shape_7.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AgOAtIgKgCIAAgQIACAAIAEABIAEABIAFABIAFABIAIgBIAFgDQACgCAAgDIABgHIAAgBQgEADgEABQgEACgEAAQgNAAgHgIQgHgIAAgQQAAgIACgGQACgGAEgFQAEgEAFgCQAFgCAGAAIAIABIAHADIABgDIATAAIAAA6QAAAJgCAGQgDAHgEADQgFAEgGABQgHACgHAAIgMgBgAgGgZQgEAFAAAIIAAAHIADAFIADADIAFABIAGgBIAFgCIAAgdIgEgBIgEgBQgHAAgDAFg',
      );
    this.shape_7.setTransform(11.425, -3.525);

    this.shape_8 = new cjs.Shape();
    this.shape_8.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AAKAiIAAghIAAgHIgBgGIgDgDIgGgBIgEABIgFADIAAAuIgVAAIAAhBIAVAAIAAAHQAFgEAEgCQAEgDAGAAQAKAAAFAHQAGAGAAAMIAAAqg',
      );
    this.shape_8.setTransform(4.075, -4.775);

    this.shape_9 = new cjs.Shape();
    this.shape_9.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AgYAdQgGgGAAgJQAAgHADgFQADgDAGgDQAFgDAIgBIAPgBIAAgBQAAgFgDgCQgFgCgHAAIgIABIgKADIgBAAIAAgQIAKgCIANgBQAQAAAIAGQAIAFAAAMIAAAsIgVAAIAAgHIgDADIgFADIgEACIgIABQgIAAgGgGgAACADIgFABQgDABgCACQgBACAAADQAAAFACACQADABAEAAIAFgBIAFgDIAAgOIgIABg',
      );
    this.shape_9.setTransform(-3.625, -4.675);

    this.shape_10 = new cjs.Shape();
    this.shape_10.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AAKAtIAAggIAAgIIgBgFIgDgDIgGgBIgEABIgFADIAAAtIgVAAIAAhaIAVAAIAAAhQAFgFAEgCQAEgCAGAAQAKAAAFAHQAGAFAAAMIAAAqg',
      );
    this.shape_10.setTransform(-10.825, -5.95);

    this.shape_11 = new cjs.Shape();
    this.shape_11.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AgYAiQgLgMAAgWQAAgUALgMQAMgMASAAIAKAAIAIACIAGACIAGADIAAAVIgCAAIgEgDIgGgEIgGgDIgIgCQgFAAgDACQgDABgEAEQgDADgDAGQgCAGAAAGQAAAIACAGQADAFADAEQAEADADACQAEABAFAAIAIgBIAGgEIAFgDIAEgEIACAAIAAAVIgGADIgGACIgHACIgLAAQgSAAgMgLg',
      );
    this.shape_11.setTransform(-18.7, -5.775);

    this.shape_12 = new cjs.Shape();
    this.shape_12.graphics
      .f('#9CDCFA')
      .s()
      .p(
        'AgRAhIgKgEIAAgRIABAAIAEACIAFADIAGADIAIABQAEAAADgCQADgBAAgDQAAgBAAAAQAAgBAAAAQAAgBgBAAQAAAAAAgBIgGgCIgFgBIgGgCQgIgCgEgEQgEgEAAgIQAAgFACgDQACgEAEgDQAEgDAGgCQAFgCAHAAQAHAAAFACQAGABAEACIAAAQIgBAAIgEgCIgEgCIgGgCIgHgBQgDAAgDACQgBAAgBABQAAAAAAABQgBAAAAABQAAAAAAABQAAAAAAABQAAAAAAABQAAAAABAAQAAABAAAAQACACAEABIAGABIAHACQAHACADADQAEAFAAAHQAAAFgCAEQgCAEgEADQgEADgGACQgGACgHAAQgHAAgHgCg',
      );
    this.shape_12.setTransform(19.525, 9.825);

    this.shape_13 = new cjs.Shape();
    this.shape_13.graphics
      .f('#9CDCFA')
      .s()
      .p(
        'AgZAlQgGgJAAgQQAAgJACgFQACgGAEgFQAEgEAFgDQAFgCAGAAIAHABIAIAEIAAgdIAUAAIAABbIgUAAIAAgHIgFADIgEADIgEACIgGABQgLAAgHgKgAgGgCQgEAFAAAJQAAAKADAEQADAEAFAAQADAAADgBIAFgCIAAggIgEgBIgEAAQgHAAgDAEg',
      );
    this.shape_13.setTransform(12.325, 8.65);

    this.shape_14 = new cjs.Shape();
    this.shape_14.graphics
      .f('#9CDCFA')
      .s()
      .p(
        'AAKAiIAAghIAAgHIgBgGIgDgDIgGgBIgEABIgFADIAAAuIgVAAIAAhBIAVAAIAAAHQAFgEAEgCQAEgDAGAAQAKAAAFAHQAGAGAAAMIAAAqg',
      );
    this.shape_14.setTransform(4.975, 9.725);

    this.shape_15 = new cjs.Shape();
    this.shape_15.graphics
      .f('#9CDCFA')
      .s()
      .p(
        'AgYAcQgGgHAAgMIAAgqIAVAAIAAAhIAAAHIABAGIADACQACACADAAIAFgCIAFgCIAAguIAVAAIAABBIgVAAIAAgIIgKAIQgDACgGAAQgKAAgFgGg',
      );
    this.shape_15.setTransform(-2.775, 9.9);

    this.shape_16 = new cjs.Shape();
    this.shape_16.graphics
      .f('#9CDCFA')
      .s()
      .p(
        'AgYAZQgJgIAAgRQAAgQAJgIQAJgKAPAAQAQAAAJAKQAJAJAAAPQAAARgJAIQgIAKgRAAQgPAAgJgKgAgEgTIgEAEQgCACgBAEIgBAJIABAKIACAGIAFAEIAEABIAFgBIAEgEIADgGIABgKIgBgJIgDgFQgCgDgCgBIgFgBIgEAAg',
      );
    this.shape_16.setTransform(-10.3, 9.8);

    this.shape_17 = new cjs.Shape();
    this.shape_17.graphics
      .f('#9CDCFA')
      .s()
      .p(
        'AAOAsIgYghIgHAAIAAAhIgWAAIAAhWIAjAAIAMAAQAFABAEADQAFADADAEQADAFAAAHQAAAKgFAGQgEAGgIADIAdAmgAgRgDIAGAAIAIgBIAEgCIADgEIABgGQAAgEgBgCQgBgCgDgBIgEgBIgGAAIgHAAg',
      );
    this.shape_17.setTransform(-17.775, 8.75);

    this.shape_18 = new cjs.Shape();
    this.shape_18.graphics
      .f('#9CDCFA')
      .s()
      .p(
        'AgWAaQgKgJAAgRQAAgOAKgKQAJgKAPAAQAQAAAHAIQAIAJAAAPIAAAGIgsAAIACAIQABADADABQADACACABIAIABIAHgBIAGgCIAFgCIADgCIADAAIAAARIgFABIgGACIgHABIgIABQgSAAgKgJgAgHgRQgEAEAAAFIAYAAQgBgGgCgEQgDgCgGAAQgFAAgDADg',
      );
    this.shape_18.setTransform(19.025, -4.7);

    this.shape_19 = new cjs.Shape();
    this.shape_19.graphics
      .f('#9CDCFA')
      .s()
      .p(
        'AgOAtIgKgCIAAgQIACAAIAEABIAEABIAFABIAFABIAIgBIAFgDQACgCAAgDIABgHIAAgBQgEADgEABQgEACgEAAQgNAAgHgIQgHgIAAgQQAAgIACgGQACgGAEgFQAEgEAFgCQAFgCAGAAIAIABIAHADIABgDIATAAIAAA6QAAAJgCAGQgDAHgEADQgFAEgGABQgHACgHAAIgMgBgAgGgZQgEAFAAAIIAAAHIADAFIADADIAFABIAGgBIAFgCIAAgdIgEgBIgEgBQgHAAgDAFg',
      );
    this.shape_19.setTransform(11.425, -3.525);

    this.shape_20 = new cjs.Shape();
    this.shape_20.graphics
      .f('#9CDCFA')
      .s()
      .p(
        'AAKAiIAAghIAAgHIgBgGIgDgDIgGgBIgEABIgFADIAAAuIgVAAIAAhBIAVAAIAAAHQAFgEAEgCQAEgDAGAAQAKAAAFAHQAGAGAAAMIAAAqg',
      );
    this.shape_20.setTransform(4.075, -4.775);

    this.shape_21 = new cjs.Shape();
    this.shape_21.graphics
      .f('#9CDCFA')
      .s()
      .p(
        'AgYAdQgGgGAAgJQAAgHADgFQADgDAGgDQAFgDAIgBIAPgBIAAgBQAAgFgDgCQgFgCgHAAIgIABIgKADIgBAAIAAgQIAKgCIANgBQAQAAAIAGQAIAFAAAMIAAAsIgVAAIAAgHIgDADIgFADIgEACIgIABQgIAAgGgGgAACADIgFABQgDABgCACQgBACAAADQAAAFACACQADABAEAAIAFgBIAFgDIAAgOIgIABg',
      );
    this.shape_21.setTransform(-3.625, -4.675);

    this.shape_22 = new cjs.Shape();
    this.shape_22.graphics
      .f('#9CDCFA')
      .s()
      .p(
        'AAKAtIAAggIAAgIIgBgFIgDgDIgGgBIgEABIgFADIAAAtIgVAAIAAhaIAVAAIAAAhQAFgFAEgCQAEgCAGAAQAKAAAFAHQAGAFAAAMIAAAqg',
      );
    this.shape_22.setTransform(-10.825, -5.95);

    this.shape_23 = new cjs.Shape();
    this.shape_23.graphics
      .f('#9CDCFA')
      .s()
      .p(
        'AgYAiQgLgMAAgWQAAgUALgMQAMgMASAAIAKAAIAIACIAGACIAGADIAAAVIgCAAIgEgDIgGgEIgGgDIgIgCQgFAAgDACQgDABgEAEQgDADgDAGQgCAGAAAGQAAAIACAGQADAFADAEQAEADADACQAEABAFAAIAIgBIAGgEIAFgDIAEgEIACAAIAAAVIgGADIgGACIgHACIgLAAQgSAAgMgLg',
      );
    this.shape_23.setTransform(-18.7, -5.775);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.shape_11 },
            { t: this.shape_10 },
            { t: this.shape_9 },
            { t: this.shape_8 },
            { t: this.shape_7 },
            { t: this.shape_6 },
            { t: this.shape_5 },
            { t: this.shape_4 },
            { t: this.shape_3 },
            { t: this.shape_2 },
            { t: this.shape_1 },
            { t: this.shape },
          ],
        })
        .to(
          {
            state: [
              { t: this.shape_23 },
              { t: this.shape_22 },
              { t: this.shape_21 },
              { t: this.shape_20 },
              { t: this.shape_19 },
              { t: this.shape_18 },
              { t: this.shape_17 },
              { t: this.shape_16 },
              { t: this.shape_15 },
              { t: this.shape_14 },
              { t: this.shape_13 },
              { t: this.shape_12 },
            ],
          },
          1,
        )
        .wait(1),
    );

    // Layer 2
    this.shape_24 = new cjs.Shape();
    this.shape_24.graphics.f('#000000').s().p('Aj3ClIAAlJIHuAAIAAFJg');
    this.shape_24.setTransform(-0.05, 2.1);

    this.timeline.addTween(cjs.Tween.get(this.shape_24).wait(2));

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-24.8, -15.4, 49.5, 34);

  (lib.redX = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer_1
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f()
      .s('#FF0000')
      .ss(5, 0, 0, 3)
      .p('ACWCWIiWiWIiVCWAAAAAICWiVAiViVICVCV');
    this.shape.setTransform(0, 0.0029);

    this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-17.5, -17.5, 35, 35);

  (lib.roundBtnshine = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 1
    this.shape = new cjs.Shape();
    this.shape.graphics
      .lf(
        ['rgba(255,255,255,0)', 'rgba(255,255,255,0.2)'],
        [0, 1],
        0,
        22.5,
        0,
        -22.5,
      )
      .s()
      .p('AiuDhQgyAAAAgyIAAldQAAgyAyAAIFdAAQAyAAAAAyIAAFdQAAAygyAAg');

    this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-22.5, -22.5, 45, 45);

  (lib.roundBtnhover = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 1
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f()
      .s('rgba(255,255,255,0.498)')
      .ss(3, 1, 1)
      .p('AjHkcIGPAAQBkAAAABkIAAFxQAABkhkAAImPAAQhkAAAAhkIAAlxQAAhkBkAAg');
    this.shape.setTransform(0, 0.025);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('rgba(255,255,255,0.098)')
      .s()
      .p('AjHEdQhkAAAAhkIAAlxQAAhkBkAAIGPAAQBkAAAABkIAAFxQAABkhkAAg');
    this.shape_1.setTransform(0, 0.025);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_1 }, { t: this.shape }] })
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.roundBtnhover,
    new cjs.Rectangle(-31.5, -29.9, 63, 59.9),
    null,
  );

  (lib.GameFrame_veil = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 1
    this.shape = new cjs.Shape();
    this.shape.graphics.f('#FFFFFF').s().p('Eg/RAvqMAAAhfTMB+jAAAMAAABfTg');
    this.shape.setTransform(400, 300);

    this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.GameFrame_veil,
    new cjs.Rectangle(-5, -5, 810, 610),
    null,
  );

  (lib.EndScreenbuttonhover = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 1
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('rgba(255,255,255,0.098)')
      .s()
      .p(
        'AqJDIQhTAAg7g6Qg6g7AAhTQAAhSA6g7QA7g6BTAAIUTAAQBTAAA6A6QA7A7AABSQAABTg7A7Qg6A6hTAAg',
      );

    this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.EndScreenbuttonhover,
    new cjs.Rectangle(-85, -20, 170, 40),
    null,
  );

  (lib.EndScreenbuttonbg = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 1
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#5645DA')
      .s()
      .p(
        'AqJDIQhTAAg7g6Qg6g7AAhTQAAhSA6g7QA7g6BTAAIUTAAQBTAAA6A6QA7A7AABSQAABTg7A7Qg6A6hTAAg',
      );

    this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.EndScreenbuttonbg,
    new cjs.Rectangle(-85, -20, 170, 40),
    null,
  );

  (lib.Background = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(5));

    // panels
    this.shape = new cjs.Shape();
    this.shape.graphics
      .lf(['#663366', '#993399'], [0, 1], 10, -78.9, 10, 79)
      .s()
      .p('A9rMgIAA4/MA7XAAAIAAUTQAAB8hYBYQhYBYh8AAg');
    this.shape.setTransform(190, 400);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .rf(['#FFFFCC', '#FF9900'], [0, 1], 10, 90, 0, 10, 90, 320.2)
      .s()
      .p('A9rZAMAAAgtTQAAh8BYhYQBYhYB8AAMA2rAAAMAAAAx/g');
    this.shape_1.setTransform(190, 160);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .rf(['#FFCC66', '#CC9900'], [0, 1], 10, 90, 0, 10, 90, 320.2)
      .s()
      .p('A9rZAMAAAgtTQAAh8BYhYQBYhYB8AAMA2rAAAMAAAAx/g');
    this.shape_2.setTransform(190, 160);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .lf(['#333366', '#003399'], [0, 1], 10, -78.9, 10, 79)
      .s()
      .p('A9rMgIAA4/MA7XAAAIAAUTQAAB8hYBYQhYBYh8AAg');
    this.shape_3.setTransform(190, 400);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .lf(['#006699', '#6699CC'], [0, 1], 10, -78.9, 10, 79)
      .s()
      .p('A9rMgIAA4/MA7XAAAIAAUTQAAB8hYBYQhYBYh8AAg');
    this.shape_4.setTransform(190, 400);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .rf(['#FFCC00', '#FF6600'], [0, 1], 10, 90, 0, 10, 90, 320.2)
      .s()
      .p('A9rZAMAAAgtTQAAh8BYhYQBYhYB8AAMA2rAAAMAAAAx/g');
    this.shape_5.setTransform(190, 160);

    this.shape_6 = new cjs.Shape();
    this.shape_6.graphics
      .lf(['#993366', '#CC6699'], [0, 1], 10, -78.9, 10, 79)
      .s()
      .p('A9rMgIAA4/MA7XAAAIAAUTQAAB8hYBYQhYBYh8AAg');
    this.shape_6.setTransform(190, 400);

    this.shape_7 = new cjs.Shape();
    this.shape_7.graphics
      .rf(['#C6DDFF', '#0099CC'], [0, 1], 10, 90, 0, 10, 90, 320.2)
      .s()
      .p('A9rZAMAAAgtTQAAh8BYhYQBYhYB8AAMA2rAAAMAAAAx/g');
    this.shape_7.setTransform(190, 160);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [] })
        .to({ state: [{ t: this.shape_1 }, { t: this.shape }] }, 1)
        .to({ state: [{ t: this.shape_3 }, { t: this.shape_2 }] }, 1)
        .to({ state: [{ t: this.shape_5 }, { t: this.shape_4 }] }, 1)
        .to({ state: [{ t: this.shape_7 }, { t: this.shape_6 }] }, 1)
        .wait(1),
    );

    // grass bg
    this.shape_8 = new cjs.Shape();
    this.shape_8.graphics
      .rf(['#DEF2A4', '#669966'], [0.004, 1], 0, 20.4, 0, 0, 20.4, 494.2)
      .s()
      .p(
        'Eg+fArwMAAAhSzQAAh8BYhYQBYhYB8AAMBznAAAQB8AABYBYQBYBYAAB8MAAABOHQAAB8hYBYQhYBYh8AAg',
      );
    this.shape_8.setTransform(400, 280);
    this.shape_8._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.shape_8).wait(2).to({ _off: false }, 0).wait(3),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(0, 0, 800, 560);

  (lib.ValueTextBlack_fields = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // line
    this.line = new lib.ValueTextBlack_line();
    this.line.name = 'line';

    this.timeline.addTween(cjs.Tween.get(this.line).wait(1));

    // denominator
    this.denominator = new cjs.Text('1', "bold 20px 'Open Sans Condensed'");
    this.denominator.name = 'denominator';
    this.denominator.textAlign = 'center';
    this.denominator.lineHeight = 29;
    this.denominator.lineWidth = 57;
    this.denominator.parent = this;
    this.denominator.setTransform(0, -4.6);

    this.timeline.addTween(cjs.Tween.get(this.denominator).wait(1));

    // numerator
    this.numerator = new cjs.Text('1', "bold 20px 'Open Sans Condensed'");
    this.numerator.name = 'numerator';
    this.numerator.textAlign = 'center';
    this.numerator.lineHeight = 29;
    this.numerator.lineWidth = 57;
    this.numerator.parent = this;
    this.numerator.setTransform(-0.25, -23.35);

    this.timeline.addTween(cjs.Tween.get(this.numerator).wait(1));

    // extraTinyText
    this.extraTinyText = new cjs.Text('1', "bold 18px 'Open Sans Condensed'");
    this.extraTinyText.name = 'extraTinyText';
    this.extraTinyText.textAlign = 'center';
    this.extraTinyText.lineHeight = 26;
    this.extraTinyText.lineWidth = 81;
    this.extraTinyText.parent = this;
    this.extraTinyText.setTransform(-0.25, -12.1);

    this.timeline.addTween(cjs.Tween.get(this.extraTinyText).wait(1));

    // tinyText
    this.tinyText = new cjs.Text('1', "bold 20px 'Open Sans Condensed'");
    this.tinyText.name = 'tinyText';
    this.tinyText.textAlign = 'center';
    this.tinyText.lineHeight = 29;
    this.tinyText.lineWidth = 81;
    this.tinyText.parent = this;
    this.tinyText.setTransform(-0.25, -15.2);

    this.timeline.addTween(cjs.Tween.get(this.tinyText).wait(1));

    // smallText
    this.smallText = new cjs.Text('1', "bold 22px 'Open Sans Condensed'");
    this.smallText.name = 'smallText';
    this.smallText.textAlign = 'center';
    this.smallText.lineHeight = 32;
    this.smallText.lineWidth = 81;
    this.smallText.parent = this;
    this.smallText.setTransform(-0.25, -16.7);

    this.timeline.addTween(cjs.Tween.get(this.smallText).wait(1));

    // largeText
    this.largeText = new cjs.Text('1', "bold 26px 'Open Sans Condensed'");
    this.largeText.name = 'largeText';
    this.largeText.textAlign = 'center';
    this.largeText.lineHeight = 37;
    this.largeText.lineWidth = 81;
    this.largeText.parent = this;
    this.largeText.setTransform(-0.25, -21.8);

    this.timeline.addTween(cjs.Tween.get(this.largeText).wait(1));

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.ValueTextBlack_fields,
    new cjs.Rectangle(-42.7, -25.3, 85, 51.6),
    null,
  );

  (lib.Scoreboard_progressMeter = function (
    mode,
    startPosition,
    loop,
    reversed,
  ) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // outline
    this.shape = new cjs.Shape();
    this.shape.graphics.f().s('#003366').ss(2, 1, 1).p('AvniVIfPAAIAAErI/PAAg');
    this.shape.setTransform(100, 0);

    this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

    // fill
    this.percentCompleteTxt = new cjs.Text('', "bold 14px 'Roboto'", '#FFFFFF');
    this.percentCompleteTxt.name = 'percentCompleteTxt';
    this.percentCompleteTxt.lineHeight = 19;
    this.percentCompleteTxt.lineWidth = 28;
    this.percentCompleteTxt.parent = this;
    this.percentCompleteTxt.setTransform(205, -9.25, 1, 1.0024);

    this.progressMeterFill = new lib.Scoreboard_progressMeter_fill();
    this.progressMeterFill.name = 'progressMeterFill';
    this.progressMeterFill.setTransform(100, 0, 1, 1, 0, 0, 0, 100, 0);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.progressMeterFill },
            { t: this.percentCompleteTxt },
          ],
        })
        .wait(1),
    );

    // Layer 2
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f()
      .s('#003366')
      .ss(2, 1, 1)
      .p('AvniVIfPAAIAAErI/PAAg');
    this.shape_1.setTransform(100, 0);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('rgba(0,51,102,0.047)')
      .s()
      .p('AvnCWIAAkrIfPAAIAAErg');
    this.shape_2.setTransform(100, 0);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_2 }, { t: this.shape_1 }] })
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.Scoreboard_progressMeter,
    new cjs.Rectangle(-1, -16, 235.9, 32),
    null,
  );

  (lib.Scoreboard_muteBtn = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer_2
    this.instance = new lib.redX('synched', 0);
    this.instance._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.instance)
        .wait(1)
        .to({ _off: false }, 0)
        .to({ _off: true }, 1)
        .wait(2),
    );

    // Layer_3
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#333333')
      .s()
      .p(
        'AACCOQAzhOgBhAQABhAgzhNIAMgIQA3BLABBKQgBBKg3BMgAgoBxQAqg2AAg7QAAg6gqg2IALgJQAXAZAMAgQANAiAAAeQAABBgvA4gAhEBSQAZghAAgxQABgpgXgjIgDgGIAMgIQAfApAAAxQAAAygfAog',
      );
    this.shape.setTransform(11.05, 0);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#666666')
      .s()
      .p(
        'AACCOQAzhOgBhAQABhAgzhNIAMgIQA3BLABBKQgBBKg3BMgAgoBxQAqg2AAg7QAAg6gqg2IALgJQAXAZAMAgQANAiAAAeQAABBgvA4gAhEBSQAZghAAgxQABgpgXgjIgDgGIAMgIQAfApAAAxQAAAygfAog',
      );
    this.shape_1.setTransform(11.05, 0);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape }] })
        .to({ state: [] }, 2)
        .to({ state: [{ t: this.shape_1 }] }, 1)
        .wait(1),
    );

    // Layer_1
    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#333333')
      .s()
      .p('AgNAzIAAhlIBehOIAAEBgAhQAuIAAhbIAyAAIAABbg');
    this.shape_2.setTransform(-8.225, 0.025);

    this.timeline.addTween(cjs.Tween.get(this.shape_2).wait(4));

    // Layer_4
    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AilDLQhFhUAAh3QAAh2BFhUQBEhUBhAAQBhAABFBUQBFBUAAB2QAAB3hFBUQhFBUhhAAQhhAAhEhUg',
      );
    this.shape_3.setTransform(0.0244, -0.0169, 0.8511, 0.6969);

    this.timeline.addTween(cjs.Tween.get(this.shape_3).wait(4));

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-20, -20, 40, 40);

  (lib.Scoreboard_musicBtn = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer_2
    this.instance = new lib.redX('synched', 0);
    this.instance._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.instance)
        .wait(1)
        .to({ _off: false }, 0)
        .to({ _off: true }, 1)
        .wait(2),
    );

    // Layer_7
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#CCCCCC')
      .s()
      .p(
        'AieAZQAAgbAfgWIAMAFIgEADQgWARAAAYQAAAbAaATIgMAEQgfgWAAgcgAB0AUQAagSAAgaQAAgYgWgSIgEgEIAMgEQAfAWAAAcQAAAbgfAWg',
      );
    this.shape.setTransform(-0.475, 7.5);
    this.shape._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.shape).wait(3).to({ _off: false }, 0).wait(1),
    );

    // Layer_5
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#333333')
      .s()
      .p(
        'AhiCOQgKgHABgNQAAgVATgRQATgQAYAAQAMAAAJAEIAAi5ICFgkIAADUQAAAWgUAQQgTARgYAAQgPAAgKgIQgIgHgBgOQAAgUAUgRQATgRAYAAQANAAAIAGIAAiYIhsAcIAACzQAAAUgTARQgUARgWAAQgRAAgIgIg',
      );
    this.shape_1.setTransform(-1.05, -1.45);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#CCCCCC')
      .s()
      .p(
        'AhiCOQgKgHABgNQAAgVATgRQATgQAYAAQAMAAAJAEIAAi5ICFgkIAADUQAAAWgUAQQgTARgYAAQgPAAgKgIQgIgHgBgOQAAgUAUgRQATgRAYAAQANAAAIAGIAAiYIhsAcIAACzQAAAUgTARQgUARgWAAQgRAAgIgIg',
      );
    this.shape_2.setTransform(-1.05, -1.45);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_1 }] })
        .to({ state: [{ t: this.shape_2 }] }, 2)
        .wait(2),
    );

    // Layer_4
    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AilDLQhFhUAAh3QAAh2BFhUQBEhUBhAAQBhAABFBUQBFBUAAB2QAAB3hFBUQhFBUhhAAQhhAAhEhUg',
      );
    this.shape_3.setTransform(0.0244, -0.0169, 0.8511, 0.6969);

    this.timeline.addTween(cjs.Tween.get(this.shape_3).wait(4));

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-20, -20, 40, 40);

  (lib.ProgressPanel = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 1
    this.correctTxt = new cjs.Text('', "bold 16px 'Roboto'", '#FFFFFF');
    this.correctTxt.name = 'correctTxt';
    this.correctTxt.lineHeight = 21;
    this.correctTxt.lineWidth = 28;
    this.correctTxt.parent = this;
    this.correctTxt.setTransform(273.65, -8.9, 1, 1.0024);

    this.roundTxt = new cjs.Text('', "bold 16px 'Roboto'", '#FFFFFF');
    this.roundTxt.name = 'roundTxt';
    this.roundTxt.lineHeight = 21;
    this.roundTxt.lineWidth = 20;
    this.roundTxt.parent = this;
    this.roundTxt.setTransform(68.05, -8.2856, 1, 1.0024);

    this.gameTxt = new cjs.Text('', "bold 16px 'Roboto'", '#FFFFFF');
    this.gameTxt.name = 'gameTxt';
    this.gameTxt.lineHeight = 21;
    this.gameTxt.lineWidth = 25;
    this.gameTxt.parent = this;
    this.gameTxt.setTransform(156.25, -8.3, 1, 1.0024);

    this.correctLbl = new cjs.Text('Correct:', "bold 15px 'Roboto'", '#FFFFFF');
    this.correctLbl.name = 'correctLbl';
    this.correctLbl.lineHeight = 20;
    this.correctLbl.lineWidth = 57;
    this.correctLbl.parent = this;
    this.correctLbl.setTransform(203.9, -8.45, 1.0021, 0.9976);

    this.bonusTxt = new cjs.Text('', "bold 16px 'Roboto'", '#FFFFFF');
    this.bonusTxt.name = 'bonusTxt';
    this.bonusTxt.lineHeight = 21;
    this.bonusTxt.lineWidth = 48;
    this.bonusTxt.parent = this;
    this.bonusTxt.setTransform(537.5, -9.3, 1, 1.0024);

    this.progressMeterMc = new lib.Scoreboard_progressMeter();
    this.progressMeterMc.name = 'progressMeterMc';
    this.progressMeterMc.setTransform(290.15, -0.7, 1, 1, 0, 0, 0, 100, -0.5);

    this.bonusLbl = new cjs.Text(
      'Bonus \nStickers:  ',
      "bold 12px 'Roboto'",
      '#FFFFFF',
    );
    this.bonusLbl.name = 'bonusLbl';
    this.bonusLbl.textAlign = 'center';
    this.bonusLbl.lineHeight = 12;
    this.bonusLbl.lineWidth = 68;
    this.bonusLbl.parent = this;
    this.bonusLbl.setTransform(493.55, -13.2, 1.0014, 0.9976);

    this.gameLbl = new cjs.Text('GAME:  ', "bold 14px 'Roboto'", '#FFFFFF');
    this.gameLbl.name = 'gameLbl';
    this.gameLbl.lineHeight = 19;
    this.gameLbl.lineWidth = 45;
    this.gameLbl.parent = this;
    this.gameLbl.setTransform(98.5, -7.45, 1.0021, 0.9976);

    this.roundLbl = new cjs.Text('ROUND:', "bold 14px 'Roboto'", '#FFFFFF');
    this.roundLbl.name = 'roundLbl';
    this.roundLbl.lineHeight = 19;
    this.roundLbl.lineWidth = 54;
    this.roundLbl.parent = this;
    this.roundLbl.setTransform(1, -7.45, 1.0021, 0.9976);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.roundLbl },
            { t: this.gameLbl },
            { t: this.bonusLbl },
            { t: this.progressMeterMc },
            { t: this.bonusTxt },
            { t: this.correctLbl },
            { t: this.gameTxt },
            { t: this.roundTxt },
            { t: this.correctTxt },
          ],
        })
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.ProgressPanel,
    new cjs.Rectangle(-1, -16.2, 588, 32),
    null,
  );

  (lib.roundBtn4 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 5
    this.btnHover = new lib.roundBtnhover();
    this.btnHover.name = 'btnHover';

    this.timeline.addTween(cjs.Tween.get(this.btnHover).wait(1));

    // Layer 3
    this.instance = new lib.roundBtnshine('synched', 0);

    this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

    // Layer 2
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AAjCSIgVAAIAAgwIAAgUIh3AAIgUAAIAAg3ICHioIBMAAIAAAUIAACWIAVAAIATAAIAAAUIAAAhIgoAAIAABEgAhFAZIAkAAIAvAAIAAg8IAAgtg',
      );
    this.shape.setTransform(-0.15, -0.5);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('rgba(0,0,0,0.498)')
      .s()
      .p(
        'AAPCSIAAgUIAzAAIAAhEIAoAAIAAghIAUAAIAAA1IgnAAIAABEgAh9BOIAAgUIB4AAIAAAUgABCAFIAAiWIAVAAIAACWgAhZAFIBUhpIAAAtIgwA8g',
      );
    this.shape_1.setTransform(1.85, 1.5);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_1 }, { t: this.shape }] })
        .wait(1),
    );

    // Layer 4
    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f()
      .s('#003366')
      .ss(3, 1, 1)
      .p('AjHkcIGPAAQBkAAAABkIAAFxQAABkhkAAImPAAQhkAAAAhkIAAlxQAAhkBkAAg');
    this.shape_2.setTransform(0, 0.025);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .rf(['#FF0000', '#990000'], [0, 1], 0, 0, 0, 0, 0, 38.3)
      .s()
      .p('AjHEdQhkAAAAhkIAAlxQAAhkBkAAIGPAAQBkAAAABkIAAFxQAABkhkAAg');
    this.shape_3.setTransform(0, 0.025);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_3 }, { t: this.shape_2 }] })
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.roundBtn4,
    new cjs.Rectangle(-31.5, -29.9, 63, 59.9),
    null,
  );

  (lib.roundBtn3 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 5
    this.btnHover = new lib.roundBtnhover();
    this.btnHover.name = 'btnHover';

    this.timeline.addTween(cjs.Tween.get(this.btnHover).wait(1));

    // Layer 3
    this.instance = new lib.roundBtnshine('synched', 0);

    this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

    // Layer 2
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#000000')
      .s()
      .p(
        'AhICQQgagGgQgHIAMADQAaAFAkAAQAgAAAVgGQAWgHARgMQAQgNAJgSQAIgRAAgVQAAgSgGgLQgGgLgJgHIgKgHQAJABAKAEQAMAEAJAHQAJAIAGALQAGALAAASQAAAVgIARQgJASgQANQgRAMgWAHQgWAGgfAAQgkAAgagFgAArgOQgLgEgKgBIAAgDQAZgFAPgTQAPgUAAgYQAAgSgIgOQgIgNgQgKIgFgDIABAAQAVAFANAIQAQAKAIANQAIAOAAASQAAAYgPAUQgPATgZAFIAAACIgJgEgAhqhHIAAgWIATgGQAWgHASAAIASABQAKACAIADIAHAFIgNgBQgSAAgWAHQgVAGgUAMg',
      );
    this.shape.setTransform(2.825, 0.6875);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('rgba(0,0,0,0.498)')
      .s()
      .p(
        'AgnAgIgRgHIAAgBIAHAAQAKAGANAFIgNgDgAA0gYIgZAAIgQAAIAAgKIALAAQANAAAKADQAHACAFAFIgFAAg',
      );
    this.shape_1.setTransform(-2.9375, 4.95);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AhICSIgMgDQgSgFgMgFIAAhAIAIAAQAKAGAMAFIASAHIAMADQAQAFAPAAQALAAAMgCQANgCAKgGQAHgGAEgHQAEgGAAgOQAAgMgFgHIgEgDQgFgFgHgCQgJgDgNAAIgLAAIgOAAIgQAAIAAgzIARAAIAbgBQAKgBAJgEQAIgEAEgGQAFgGAAgMQAAgJgFgFIgEgEIgHgEQgIgEgKgCIgRAAQgSAAgWAGIgTAGQgLAFgLAHIgIAAIAAg/QARgGAbgHQAcgFAcAAQAaAAAVAEQARAEAMAGIAFADQAQAKAIANQAIAOAAATQAAAXgPAUQgPATgZAFIAAADQAKABALAEIAJADIACABIAKAHQAJAJAGALQAGAKAAATQAAAUgIASQgJARgQANQgRANgWAGQgWAGgfAAQgkABgagGg',
      );
    this.shape_2.setTransform(-0.175, -0.55);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [{ t: this.shape_2 }, { t: this.shape_1 }, { t: this.shape }],
        })
        .wait(1),
    );

    // Layer 4
    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f()
      .s('#003366')
      .ss(3, 1, 1)
      .p('AjHkcIGPAAQBkAAAABkIAAFxQAABkhkAAImPAAQhkAAAAhkIAAlxQAAhkBkAAg');
    this.shape_3.setTransform(0, 0.025);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .rf(['#351DE2', '#2C2659'], [0, 1], 0, 0, 0, 0, 0, 38.3)
      .s()
      .p('AjHEdQhkAAAAhkIAAlxQAAhkBkAAIGPAAQBkAAAABkIAAFxQAABkhkAAg');
    this.shape_4.setTransform(0, 0.025);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_4 }, { t: this.shape_3 }] })
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.roundBtn3,
    new cjs.Rectangle(-31.5, -29.9, 63, 59.9),
    null,
  );

  (lib.roundBtn2 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 5
    this.btnHover = new lib.roundBtnhover();
    this.btnHover.name = 'btnHover';

    this.timeline.addTween(cjs.Tween.get(this.btnHover).wait(1));

    // Layer 3
    this.instance = new lib.roundBtnshine('synched', 0);

    this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

    // Layer 2
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('rgba(0,0,0,0.498)')
      .s()
      .p(
        'AhxCLIAAgUIDPAAIAAgkIAUAAIAAA4gAgjA/IAZgUQARgNASgQQAcgaAOgZQAOgZAAgbQAAgdgNgUIAEAEQAdAXAAAqQAAAcgOAYQgOAYgcAaQgRARgSANgAhphKIAAgcQALgGAMgFQATgHASAAQAYgBANALQAHAGACAIQgKgFgQAAQgSABgTAHQgUAIgRALg',
      );
    this.shape.setTransform(2.625, 2.15);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AhdCUIgUAAIAAgwQAagTAagVQAbgVAPgQQAXgXAKgQQAKgRAAgQQAAgKgDgHQgDgIgHgGQgMgLgYAAQgSAAgTAIQgMAEgLAGIgOAJIgGAAIAAhBQANgGAcgGQAagGAcAAQA1AAAdAXQAJAHAHAJQANAUAAAdQAAAbgOAZQgOAYgcAaQgSARgSANIgYAUIAtAAIBUAAIAAAUIAAAjg',
      );
    this.shape_1.setTransform(0.625, -0.825);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_1 }, { t: this.shape }] })
        .wait(1),
    );

    // Layer 4
    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f()
      .s('#003366')
      .ss(3, 1, 1)
      .p('AjHkcIGPAAQBkAAAABkIAAFxQAABkhkAAImPAAQhkAAAAhkIAAlxQAAhkBkAAg');
    this.shape_2.setTransform(0, 0.025);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .rf(['#1BB448', '#265945'], [0, 1], 0, 0, 0, 0, 0, 38.3)
      .s()
      .p('AjHEdQhkAAAAhkIAAlxQAAhkBkAAIGPAAQBkAAAABkIAAFxQAABkhkAAg');
    this.shape_3.setTransform(0, 0.025);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_3 }, { t: this.shape_2 }] })
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.roundBtn2,
    new cjs.Rectangle(-31.5, -29.9, 63, 59.9),
    null,
  );

  (lib.roundBtn1 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 5
    this.btnHover = new lib.roundBtnhover();
    this.btnHover.name = 'btnHover';

    this.timeline.addTween(cjs.Tween.get(this.btnHover).wait(1));

    // Layer 3
    this.instance = new lib.roundBtnshine('synched', 0);

    this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

    // Layer 2
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('rgba(0,0,0,0.498)')
      .s()
      .p(
        'AhgCSIAAgUICtAAIAAgfIAUAAIAAAzgAARBLIAAjcIAUAAIAADcgAhgg6IAAgUIApAAIAAAUg',
      );
    this.shape.setTransform(1.5, 1.425);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AhMCSIgUAAIAAgzIA9AAIAAiFIAAgUIgpAAIgUAAIAAgvQAOAAANgCQANgCAJgEQAJgFAFgHQAGgIABgMIA/AAIAAAUIAADcIAUAAIAoAAIAAAUIAAAfg',
      );
    this.shape_1.setTransform(-0.5, -0.575);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_1 }, { t: this.shape }] })
        .wait(1),
    );

    // Layer 4
    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f()
      .s('#003366')
      .ss(3, 1, 1)
      .p('AjHkcIGPAAQBkAAAABkIAAFxQAABkhkAAImPAAQhkAAAAhkIAAlxQAAhkBkAAg');
    this.shape_2.setTransform(0, 0.025);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .rf(['#A415EA', '#541D67'], [0, 1], 0, 0, 0, 0, 0, 38.3)
      .s()
      .p('AjHEdQhkAAAAhkIAAlxQAAhkBkAAIGPAAQBkAAAABkIAAFxQAABkhkAAg');
    this.shape_3.setTransform(0, 0.025);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_3 }, { t: this.shape_2 }] })
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.roundBtn1,
    new cjs.Rectangle(-31.5, -29.9, 63, 59.9),
    null,
  );

  (lib.nextBtn = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 1
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AgOBZIgNgFIgNgGQgFgDgEgGIAPgUQAGAGAHAEQAIAEAJAAQANAAAIgHQAHgHAAgNIAAgHQgGAGgHADQgIAEgJAAQgLAAgKgFQgKgFgGgJQgHgIgDgMQgEgLAAgOIAAgCQAAgOAEgMQADgMAHgIQAGgKAKgEQAKgFALABQALgBAHAEQAJAEAFAGIACgMIAeAAIAAB6QAAANgEAKQgFALgIAGQgIAIgLADQgLAEgNAAIgMgBgAgIg6QgGADgCAEQgEAFgCAHQgBAIAAAHIAAACQAAAJABAGQACAGAEAFQACAFAGADQAEACAGAAQAIAAAFgCQAGgDADgGIAAg1QgDgFgGgDQgFgDgIAAQgFAAgFADg',
      );
    this.shape.setTransform(62.3, 4.25);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AAVBAIAAhQQAAgFgCgFQgBgDgDgDIgGgDIgJgBQgGAAgFADQgGADgDAGIAABYIgiAAIAAh+IAgAAIABAQQAHgJAJgEQAIgFALABQAJgBAIADQAHADAFAFQAGAGADAJQADAKAAANIAABPg',
      );
    this.shape_1.setTransform(48.975, 1.75);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AgQBYIAAh+IAhAAIAAB+gAgHg2QgDgBgDgCIgEgGIgBgHQAAgIAFgFQAFgEAIgBIAIACIAGADQACADACADIABAHIgBAHIgEAGQgDACgDABQgEABgEAAQgDAAgEgBg',
      );
    this.shape_2.setTransform(39.125, -0.65);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AgjBZIgDgBIgEAAIgDgBIAAgaIACAAIADAAIAIgBIAHgBIAEgFIADgGIAEgJIgth/IAlAAIAWBPIAYhPIAkAAIgzCRIgEALQgDAFgEAFQgFAFgGADQgHADgKAAIgFAAg',
      );
    this.shape_3.setTransform(29.925, 4.4);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AgdA/QgIgDgGgFQgGgFgDgHQgDgHAAgIQAAgKADgIQAEgIAHgEQAIgGALgCQALgDANAAIAPAAIAAgHQAAgJgEgGQgFgFgIAAQgJAAgFAEQgFAEAAAIIghAAQAAgJADgHQAEgHAHgGQAHgFAKgEQAKgDALAAQALAAAKADQAJADAHAFQAHAGAEAIQADAJAAALIAAA0IABAKIABAIIABAGIACAFIAAACIgiAAQgCgEgBgHQgFAGgIAEQgHAEgLAAQgJAAgIgDgAgHAHQgFACgDACQgDADgCADQgBAEAAAEQAAAGAEAFQAEAEAIAAIAHgBIAHgDIAFgEIADgFIAAgVIgOAAQgFAAgFABg',
      );
    this.shape_4.setTransform(17.475, 1.875);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics.f('#FFFFFF').s().p('AgQBaIAAizIAhAAIAACzg');
    this.shape_5.setTransform(7.95, -0.8);

    this.shape_6 = new cjs.Shape();
    this.shape_6.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'Ag4BZIAAivIAfAAIABANQAGgIAJgDQAHgEAKAAQAMAAAJAFQAJAEAHAIQAFAJAEAMQADAMAAAOIAAADQAAAOgDALQgEALgFAJQgHAJgJAEQgJAGgMAAQgJgBgIgDQgIgEgFgGIAAA8gAgOg5QgFACgDAHIAAAyQADAHAFADQAFADAJAAQAGAAAEgDQAFgDADgFQADgEABgHQACgHAAgHIAAgDQAAgHgCgHQgCgHgCgFQgDgFgFgDQgFgDgFAAQgJAAgFAEg',
      );
    this.shape_6.setTransform(-1.75, 4.2);

    this.shape_7 = new cjs.Shape();
    this.shape_7.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'Ag4BZIAAivIAgAAIABANQAGgIAHgDQAIgEAJAAQANAAAJAFQAKAEAFAIQAHAJADAMQADAMAAAOIAAADQAAAOgDALQgDALgHAJQgFAJgKAEQgJAGgMAAQgJgBgIgDQgHgEgGgGIAAA8gAgOg5QgFACgDAHIAAAyQADAHAFADQAGADAIAAQAFAAAGgDQAEgDADgFQACgEACgHQABgHAAgHIAAgDQAAgHgBgHQgBgHgEgFQgDgFgEgDQgFgDgFAAQgIAAgGAEg',
      );
    this.shape_7.setTransform(-21.25, 4.2);

    this.shape_8 = new cjs.Shape();
    this.shape_8.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AgUA9QgLgFgJgIQgIgJgEgLQgFgLABgNIAAgEQAAgOADgMQAFgMAHgIQAIgJALgFQALgFAMAAQAPAAAKAFQAKAEAIAIQAGAIAEAMQADALAAAOIAAAOIhPAAQAAAGADAFQADAFAEAEQAEADAFACQAEACAHAAQAJAAAIgDQAHgEAGgHIARATQgDAEgFAEIgLAIIgNAFQgJACgIAAQgOAAgMgFgAgHgjQgEABgEAEQgDADgBAFIgDALIAuAAIAAgDIgBgJQgCgFgDgDQgCgDgFgCQgDgBgHAAQgEAAgEACg',
      );
    this.shape_8.setTransform(-34.6, 1.875);

    this.shape_9 = new cjs.Shape();
    this.shape_9.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AgUA9QgMgFgIgIQgIgJgEgLQgFgLABgNIAAgEQAAgOADgMQAFgMAIgIQAHgJALgFQALgFAMAAQAOAAALAFQAKAEAHAIQAHAIAEAMQAEALAAAOIAAAOIhQAAQAAAGADAFQADAFAEAEQAEADAFACQAEACAGAAQAKAAAIgDQAHgEAGgHIARATQgDAEgFAEIgLAIIgNAFQgJACgIAAQgOAAgMgFgAgHgjQgFABgDAEQgCADgCAFIgDALIAuAAIAAgDIgBgJQgCgFgDgDQgCgDgFgCQgDgBgHAAQgEAAgEACg',
      );
    this.shape_9.setTransform(-47.55, 1.875);

    this.shape_10 = new cjs.Shape();
    this.shape_10.graphics
      .f('#FFFFFF')
      .s()
      .p('AAcBVIgrhEIgSAUIAAAwIgkAAIAAipIAkAAIAABNIAPgVIArg4IArAAIg9BLIA/Beg');
    this.shape_10.setTransform(-60.925, -0.325);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.shape_10 },
            { t: this.shape_9 },
            { t: this.shape_8 },
            { t: this.shape_7 },
            { t: this.shape_6 },
            { t: this.shape_5 },
            { t: this.shape_4 },
            { t: this.shape_3 },
            { t: this.shape_2 },
            { t: this.shape_1 },
            { t: this.shape },
          ],
        })
        .wait(1),
    );

    // Layer 3
    this.btnHover = new lib.EndScreenbuttonhover();
    this.btnHover.name = 'btnHover';

    this.timeline.addTween(cjs.Tween.get(this.btnHover).wait(1));

    // Layer 2
    this.instance = new lib.EndScreenbuttonbg();

    this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.nextBtn,
    new cjs.Rectangle(-85, -20, 170, 40),
    null,
  );

  (lib.moreBtn = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 3
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AgUA9QgLgFgJgIQgIgJgEgLQgEgLAAgNIAAgEQAAgOADgMQAFgMAIgIQAHgJALgFQALgFAMAAQAOAAALAFQAKAEAHAIQAIAIADAMQAEALAAAOIAAAOIhQAAQAAAGADAFQACAFAFAEQAEADAFACQAEACAGAAQAKAAAHgDQAJgEAFgHIARATQgDAEgFAEIgLAIIgNAFQgIACgJAAQgOAAgMgFgAgHgjQgEABgDAEQgEADgBAFIgDALIAuAAIAAgDIgBgJQgBgFgEgDQgCgDgEgCQgFgBgGAAQgEAAgEACg',
      );
    this.shape.setTransform(22.75, 1.875);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AA5BAIAAhPQAAgHgBgEQgCgEgDgCQgCgDgEAAIgHgBQgIAAgGAEQgFAEgDAGIAAACIAAABIAABTIggAAIAAhPQAAgHgCgEQAAgDgDgDIgGgDIgJgBQgHAAgFADQgFADgDAGIAABYIgiAAIAAh+IAgAAIABAPQAGgIAKgEQAIgFAMABQAMgBAIAFQAIAEAFALQAGgJAJgGQAKgEANAAQAJgBAIADQAHADAGAFQAFAGADAKQADAIAAAOIAABPg',
      );
    this.shape_1.setTransform(5.75, 1.75);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AgYA9QgMgFgHgJQgIgIgEgMQgEgMAAgOIAAgBQAAgOAEgMQAEgMAIgIQAHgJALgFQAMgFANAAQAOAAAMAFQALAFAIAJQAHAIAEAMQAEAMAAAOIAAABQAAAOgEAMQgEAMgHAIQgIAJgLAFQgLAFgPAAQgNAAgLgFgAgLgiQgFADgDAFQgDAFgCAHQgBAGAAAIIAAABQAAAIABAHQACAGADAGQADAEAFADQAFADAGAAQAHAAAFgDQAFgDADgEQADgGACgGQABgHAAgIIAAgBQAAgIgBgGQgCgHgDgFQgDgFgFgDQgFgDgHAAQgGAAgFADg',
      );
    this.shape_2.setTransform(-11.425, 1.875);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#FFFFFF')
      .s()
      .p('AAjBVIAAhJIhEAAIAABJIgkAAIAAipIAkAAIAABFIBEAAIAAhFIAjAAIAACpg');
    this.shape_3.setTransform(-26.7, -0.325);

    this.btnHover = new lib.EndScreenbuttonhover();
    this.btnHover.name = 'btnHover';

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.btnHover },
            { t: this.shape_3 },
            { t: this.shape_2 },
            { t: this.shape_1 },
            { t: this.shape },
          ],
        })
        .wait(1),
    );

    // Layer 2
    this.instance = new lib.EndScreenbuttonbg();

    this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.moreBtn,
    new cjs.Rectangle(-85, -20, 170, 40),
    null,
  );

  (lib.continueBtn = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 1
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#FFFFFF')
      .s()
      .p('Ag1BQIAAifIBqAAIAAAeIhBAAIAAAfIA9AAIAAAdIg9AAIAABFg');
    this.shape.setTransform(66.3, -0.6);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#FFFFFF')
      .s()
      .p('AgqBQIAAgcIAXAAIAAhnIgXAAIAAgcIBVAAIAAAcIgXAAIAABnIAXAAIAAAcg');
    this.shape_1.setTransform(53.975, -0.6);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#FFFFFF')
      .s()
      .p('AgUBQIg3ifIAqAAIAiBrIAihrIApAAIg3Cfg');
    this.shape_2.setTransform(41.225, -0.6);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AgoAwQgTgRAAgeQAAgcARgSQARgSAeAAQAcAAANAPQAOAPAAAcIAAANIhRAAQAAAIADAGQAEAFAEAEQAFADAFABQAHACAIAAIAMgCIAMgDIAIgFIAHgEIAEAAIAAAfIgIADIgLAEIgNACIgQABQggAAgSgQgAgPggQgFAHgBALIAsAAQAAgMgGgGQgEgGgMAAQgJAAgHAGg',
      );
    this.shape_3.setTransform(20.85, 1.325);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AguAyQgJgLgBgWIAAhOIAmAAIAAA7IABAPQAAAGACAEQACAEADACQAEABAGAAQAEAAAFgBIAKgGIAAhUIAmAAIAAB3IgmAAIAAgNQgKAJgIADQgIAFgLAAQgRAAgLgMg',
      );
    this.shape_4.setTransform(7.2, 1.55);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AASA+IAAg8IAAgOQgBgGgBgEQgCgEgEgCQgEgCgGAAIgIACQgEABgGAEIAABVIglAAIAAh4IAlAAIAAAOQAJgIAJgFQAHgEALAAQATAAAJALQALAMgBAWIAABOg',
      );
    this.shape_5.setTransform(-6.8, 1.2);

    this.shape_6 = new cjs.Shape();
    this.shape_6.graphics
      .f('#FFFFFF')
      .s()
      .p('AgSBTIAAh3IAlAAIAAB3gAgTg1IAAgdIAnAAIAAAdg');
    this.shape_6.setTransform(-17.225, -0.95);

    this.shape_7 = new cjs.Shape();
    this.shape_7.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AgTBFQgKgJAAgWIAAg3IgOAAIAAgaIAOAAIAAgjIAkAAIAAAjIAlAAIAAAaIglAAIAAAqIABALQAAAEABAEQACAEAEACQAEACAHAAIAIgBIAHgCIADAAIAAAaIgNADIgRABQgWAAgLgKg',
      );
    this.shape_7.setTransform(-25.05, -0.225);

    this.shape_8 = new cjs.Shape();
    this.shape_8.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AATA+IAAg8IgBgOQgBgGgBgEQgCgEgEgCQgEgCgFAAIgJACQgEABgGAEIAABVIgmAAIAAh4IAmAAIAAAOQAJgIAJgFQAIgEALAAQASAAAKALQAKAMgBAWIAABOg',
      );
    this.shape_8.setTransform(-36.7, 1.2);

    this.shape_9 = new cjs.Shape();
    this.shape_9.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AgtAvQgQgRAAgeQAAgdAQgRQARgRAcAAQAeAAAQARQAQARAAAdQAAAegQARQgQARgeAAQgcAAgRgRgAgIgjQgEACgEAEQgDAFgCAHQgCAHAAAKQAAALACAHIAFALQADAEAEACQAFACAEAAQAFAAAFgCQAEgCADgEQADgEACgHQACgGAAgMQAAgKgCgHQgCgHgDgEQgDgFgEgBQgEgCgGAAQgEAAgEABg',
      );
    this.shape_9.setTransform(-50.625, 1.375);

    this.shape_10 = new cjs.Shape();
    this.shape_10.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AgsA+QgVgXAAgnQAAglAVgXQAVgWAjAAIARABIAPADIAMAFIAKAEIAAAmIgEAAIgHgFIgKgIQgGgEgGgCQgHgCgIAAQgIAAgIACQgFADgHAHQgGAGgEAKQgEALAAAOQAAAOAEALQAEAJAHAHQAGAGAGACQAIADAIAAQAHAAAIgDQAHgCAFgDIAJgHIAHgGIAEAAIAAAmIgKAEIgMAFIgOADIgSABQgjAAgVgVg',
      );
    this.shape_10.setTransform(-64.75, -0.6);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.shape_10 },
            { t: this.shape_9 },
            { t: this.shape_8 },
            { t: this.shape_7 },
            { t: this.shape_6 },
            { t: this.shape_5 },
            { t: this.shape_4 },
            { t: this.shape_3 },
            { t: this.shape_2 },
            { t: this.shape_1 },
            { t: this.shape },
          ],
        })
        .wait(1),
    );

    // Layer 3
    this.btnHover = new lib.EndScreenbuttonhover();
    this.btnHover.name = 'btnHover';

    this.timeline.addTween(cjs.Tween.get(this.btnHover).wait(1));

    // Layer 2
    this.instance = new lib.EndScreenbuttonbg();

    this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.continueBtn,
    new cjs.Rectangle(-85, -20, 170, 40),
    null,
  );

  (lib.EndScreen = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 2
    this.stickersText = new cjs.Text(
      'Congratulations!',
      "bold 32px 'Roboto'",
      '#003399',
    );
    this.stickersText.name = 'stickersText';
    this.stickersText.textAlign = 'center';
    this.stickersText.lineHeight = 44;
    this.stickersText.lineWidth = 498;
    this.stickersText.parent = this;
    this.stickersText.setTransform(396.95, 319.5);

    this.beforeScoreText = new cjs.Text(
      'You scored',
      "bold 30px 'Roboto'",
      '#003399',
    );
    this.beforeScoreText.name = 'beforeScoreText';
    this.beforeScoreText.textAlign = 'center';
    this.beforeScoreText.lineHeight = 42;
    this.beforeScoreText.lineWidth = 451;
    this.beforeScoreText.parent = this;
    this.beforeScoreText.setTransform(401.5, 121.35);

    this.pointsText = new cjs.Text('0', "bold 60px 'Roboto'", '#003399');
    this.pointsText.name = 'pointsText';
    this.pointsText.textAlign = 'center';
    this.pointsText.lineHeight = 78;
    this.pointsText.lineWidth = 196;
    this.pointsText.parent = this;
    this.pointsText.setTransform(400.95, 144.8);

    this.afterScoreText = new cjs.Text(
      'points',
      "bold 30px 'Roboto'",
      '#003399',
    );
    this.afterScoreText.name = 'afterScoreText';
    this.afterScoreText.textAlign = 'center';
    this.afterScoreText.lineHeight = 42;
    this.afterScoreText.lineWidth = 488;
    this.afterScoreText.parent = this;
    this.afterScoreText.setTransform(401.95, 203.7);

    this.messageText = new cjs.Text(
      'Congratulations!',
      "bold 40px 'Roboto'",
      '#003399',
    );
    this.messageText.name = 'messageText';
    this.messageText.textAlign = 'center';
    this.messageText.lineHeight = 54;
    this.messageText.lineWidth = 498;
    this.messageText.parent = this;
    this.messageText.setTransform(396.95, 243.95);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.messageText },
            { t: this.afterScoreText },
            { t: this.pointsText },
            { t: this.beforeScoreText },
            { t: this.stickersText },
          ],
        })
        .wait(1),
    );

    // Layer 4
    this.continueBtn = new lib.continueBtn();
    this.continueBtn.name = 'continueBtn';
    this.continueBtn.setTransform(424.95, 421);

    this.moreBtn = new lib.moreBtn();
    this.moreBtn.name = 'moreBtn';
    this.moreBtn.setTransform(586.1, 421, 0.7647, 1);

    this.nextBtn = new lib.nextBtn();
    this.nextBtn.name = 'nextBtn';
    this.nextBtn.setTransform(242.05, 421);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.nextBtn },
            { t: this.moreBtn },
            { t: this.continueBtn },
          ],
        })
        .wait(1),
    );

    // bg
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'EgmRAfQQh8AAhYhYQhYhYAAh8MAAAg1HQAAh8BYhYQBYhYB8AAMBMjAAAQB8AABYBYQBYBYAAB8MAAAA1HQAAB8hYBYQhYBYh8AAg',
      );
    this.shape.setTransform(400, 275);

    this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

    // shadow
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('rgba(0,0,0,0.098)')
      .s()
      .p(
        'EgmRAfQQh8AAhYhYQhYhYAAh8MAAAg1HQAAh8BYhYQBYhYB8AAMBMjAAAQB8AABYBYQBYBYAAB8MAAAA1HQAAB8hYBYQhYBYh8AAg',
      );
    this.shape_1.setTransform(405, 280);

    this.timeline.addTween(cjs.Tween.get(this.shape_1).wait(1));

    // veil
    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('rgba(255,255,255,0.498)')
      .s()
      .p('Eg+fAu4MAAAhdvMB8/AAAMAAABdvg');
    this.shape_2.setTransform(400, 300);

    this.timeline.addTween(cjs.Tween.get(this.shape_2).wait(1));

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.EndScreen,
    new cjs.Rectangle(0, 0, 800, 600),
    null,
  );

  (lib.comsuntexsymbolsValueTextBlack = function (
    mode,
    startPosition,
    loop,
    reversed,
  ) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // fields
    this.fields = new lib.ValueTextBlack_fields();
    this.fields.name = 'fields';

    this.timeline.addTween(cjs.Tween.get(this.fields).wait(1));

    // glow
    this.textGlow = new lib.ValueText_glow();
    this.textGlow.name = 'textGlow';

    this.timeline.addTween(cjs.Tween.get(this.textGlow).wait(1));

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.comsuntexsymbolsValueTextBlack,
    new cjs.Rectangle(-42.7, -30, 85, 60),
    null,
  );

  (lib.textMovieClip = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };
    this.frame_2 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this)
        .call(this.frame_0)
        .wait(1)
        .call(this.frame_1)
        .wait(1)
        .call(this.frame_2)
        .wait(1),
    );

    // Layer 1
    this.textb = new lib.comsuntexsymbolsValueTextBlack();
    this.textb.name = 'textb';
    this.textb.setTransform(-0.05, 0.95, 1.2185, 1.0002, 0, 0, 0, -0.1, 0);

    this.timeline.addTween(cjs.Tween.get(this.textb).wait(3));

    // Layer 2
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AibCbQhAhAAAhbQAAhaBAhAQBBhBBaAAQBbAABBBBQBABAAABaQAABbhABAQhBBBhbAAQhaAAhBhBg',
      );
    this.shape.setTransform(0.8, -0.05);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#DCF3A8')
      .s()
      .p(
        'AibCbQhAhAAAhbQAAhaBAhAQBBhBBaAAQBbAABBBBQBABAAABaQAABbhABAQhBBBhbAAQhaAAhBhBg',
      );
    this.shape_1.setTransform(0.8, -0.05);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [] })
        .to({ state: [{ t: this.shape }] }, 1)
        .to({ state: [{ t: this.shape_1 }] }, 1)
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-52, -29, 103.6, 60);

  (lib.start = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = { button: 0 };
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // Layer 1
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#FFFFFF')
      .s()
      .p('AgNA1IAAhSIgXAAIAAgXIBJAAIAAAXIgXAAIAABSg');
    this.shape.setTransform(132.825, -102.975);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AAKA1IgZgpIAAApIgdAAIAAhpIAsAAQAIAAAGACQAGACAFAFQAJAKAAAOQAAAHgCAGQgDAGgFADQgEAFgJACIAhArgAgPgFIAEAAQAJAAACgCIAEgFIABgGIgBgGIgEgEQgCgDgJAAIgEAAg',
      );
    this.shape_1.setTransform(124.55, -102.975);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#FFFFFF')
      .s()
      .p('AAaA1IgHgSIglAAIgHASIgeAAIAphpIAeAAIAoBpgAgKAOIAWAAIgMghg');
    this.shape_2.setTransform(113.325, -102.975);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#FFFFFF')
      .s()
      .p('AgNA1IAAhSIgXAAIAAgXIBJAAIAAAXIgXAAIAABSg');
    this.shape_3.setTransform(104.525, -102.975);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AgmArIAMgWQAMALAMAAQAGAAAEgDQACgDAAgEQAAgFgDgCQgEgCgIgDQgQgFgFgEQgIgGAAgPQAAgQALgKQAKgJAOAAQASAAAQAIIgLAWQgJgHgJAAQgGAAgCADQgDADAAADQAAAFAGADIAMAEQAOAEAGAHQAGAGAAAMQAAAVgNAJQgMAIgPAAQgUAAgRgNg',
      );
    this.shape_4.setTransform(96.175, -102.95);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics.f('#5877CA').s().p('AluCeIAAk6ILdAAIAAE6g');
    this.shape_5.setTransform(115.75, -103.25);

    this.clockDisplay = new lib.comsuntexsymbolsValueTextBlack();
    this.clockDisplay.name = 'clockDisplay';
    this.clockDisplay.setTransform(
      115.65,
      -102.5,
      1.2185,
      1.25,
      0,
      0,
      0,
      -0.4,
      0,
    );
    this.clockDisplay.alpha = 0.3984;

    this.shape_6 = new cjs.Shape();
    this.shape_6.graphics.f('#5877F9').s().p('Al9CsIAAlXIL8AAIAAFXg');
    this.shape_6.setTransform(117.25, -101.825);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.shape_5 },
            { t: this.shape_4 },
            { t: this.shape_3 },
            { t: this.shape_2 },
            { t: this.shape_1 },
            { t: this.shape },
          ],
        })
        .to({ state: [{ t: this.shape_6 }, { t: this.clockDisplay }] }, 1)
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(64.1, -140, 103.6, 75);

  (lib.numberPanel = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };
    this.frame_2 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this)
        .call(this.frame_0)
        .wait(1)
        .call(this.frame_1)
        .wait(1)
        .call(this.frame_2)
        .wait(1),
    );

    // Layer 1
    this.t = new lib.textMovieClip();
    this.t.name = 't';
    this.t.setTransform(28, 50.05, 1, 1, 0, 0, 0, 0, 8);

    this.text3 = new lib.comsuntexsymbolsValueTextBlack();
    this.text3.name = 'text3';
    this.text3.setTransform(27.95, 3.85, 1.2185, 1.0002, 0, 0, 0, -0.1, 0);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.text3 }, { t: this.t }] })
        .wait(3),
    );

    // tile
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#BBE42E')
      .s()
      .p('AmyH0QhBAAAAhBIAAtlQAAhBBBAAINlAAQBBAAAABBIAANlQAABBhBAAg');
    this.shape.setTransform(27.5, 22);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#DCF3A8')
      .s()
      .p('AmyH0QhBAAAAhBIAAtlQAAhBBBAAINlAAQBBAAAABBIAANlQAABBhBAAg');
    this.shape_1.setTransform(27.5, 22);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#7AA8F9')
      .s()
      .p('AmyH0QhBAAAAhBIAAtlQAAhBBBAAINlAAQBBAAAABBIAANlQAABBhBAAg');
    this.shape_2.setTransform(27.5, 22);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape }] })
        .to({ state: [{ t: this.shape_1 }] }, 1)
        .to({ state: [{ t: this.shape_2 }] }, 1)
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-24, -28, 103.6, 101);

  (lib.mPiece = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 1
    this.t = new lib.textMovieClip();
    this.t.name = 't';
    this.t.setTransform(0, 9.05, 1, 1, 0, 0, 0, 0, 8);

    this.timeline.addTween(cjs.Tween.get(this.t).wait(1));

    // Layer_1
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AibCbQhAhAAAhbQAAhaBAhAQBBhBBaAAQBbAABBBBQBABAAABaQAABbhABAQhBBBhbAAQhaAAhBhBg',
      );
    this.shape.setTransform(0.8, -0.05);

    this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.mPiece,
    new cjs.Rectangle(-52, -28, 103.6, 60),
    null,
  );

  (lib.comsuntexsymbolsScoreboard = function (
    mode,
    startPosition,
    loop,
    reversed,
  ) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // text
    this.progressPanel = new lib.ProgressPanel();
    this.progressPanel.name = 'progressPanel';
    this.progressPanel.setTransform(283.95, 20.7, 1, 1, 0, 0, 0, 274.1, 0);

    this.timeline.addTween(cjs.Tween.get(this.progressPanel).wait(1));

    // buttons
    this.muteBtn = new lib.Scoreboard_muteBtn();
    this.muteBtn.name = 'muteBtn';
    this.muteBtn.setTransform(778.45, 20);

    this.musicBtn = new lib.Scoreboard_musicBtn();
    this.musicBtn.name = 'musicBtn';
    this.musicBtn.setTransform(738.45, 20);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.musicBtn }, { t: this.muteBtn }] })
        .wait(1),
    );

    // bg
    this.shape = new cjs.Shape();
    this.shape.graphics.f('#000000').s().p('Eg+zADSIAAmjMB9nAAAIAAGjg');
    this.shape.setTransform(400, 21);

    this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.comsuntexsymbolsScoreboard,
    new cjs.Rectangle(-2, 0, 804, 42),
    null,
  );

  (lib.PracticeMenu = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 2
    this.text = new cjs.Text(
      'Select a practice round:',
      "bold 24px 'Roboto'",
      '#003399',
    );
    this.text.textAlign = 'center';
    this.text.lineHeight = 35;
    this.text.parent = this;
    this.text.setTransform(398.05, 244.75);

    this.round4Btn = new lib.roundBtn4();
    this.round4Btn.name = 'round4Btn';
    this.round4Btn.setTransform(550, 330.6, 1.1111, 1.1106);

    this.round3Btn = new lib.roundBtn3();
    this.round3Btn.name = 'round3Btn';
    this.round3Btn.setTransform(450, 330.6, 1.1111, 1.1106);

    this.round2Btn = new lib.roundBtn2();
    this.round2Btn.name = 'round2Btn';
    this.round2Btn.setTransform(350, 330.6, 1.1111, 1.1106);

    this.round1Btn = new lib.roundBtn1();
    this.round1Btn.name = 'round1Btn';
    this.round1Btn.setTransform(250, 330.6, 1.1111, 1.1106);

    this.text_1 = new cjs.Text(
      "You've finished earning stickers,\nbut you can still practice!",
      "bold 26px 'Roboto'",
      '#003399',
    );
    this.text_1.textAlign = 'center';
    this.text_1.lineHeight = 37;
    this.text_1.parent = this;
    this.text_1.setTransform(399.05, 135.9);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.text_1 },
            { t: this.round1Btn },
            { t: this.round2Btn },
            { t: this.round3Btn },
            { t: this.round4Btn },
            { t: this.text },
          ],
        })
        .wait(1),
    );

    // Layer 4
    this.moreBtn = new lib.moreBtn();
    this.moreBtn.name = 'moreBtn';
    this.moreBtn.setTransform(398.05, 425.4);

    this.timeline.addTween(cjs.Tween.get(this.moreBtn).wait(1));

    // bg
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'EgiXAfQQh8AAhYhYQhYhYAAh8MAAAg1HQAAh8BYhYQBYhYB8AAMBEvAAAQB8AABYBYQBYBYAAB8MAAAA1HQAAB8hYBYQhYBYh8AAg',
      );
    this.shape.setTransform(400, 280);

    this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

    // shadow
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('rgba(0,0,0,0.098)')
      .s()
      .p(
        'EgiXAfQQh8AAhYhYQhYhYAAh8MAAAg1HQAAh8BYhYQBYhYB8AAMBEvAAAQB8AABYBYQBYBYAAB8MAAAA1HQAAB8hYBYQhYBYh8AAg',
      );
    this.shape_1.setTransform(405, 285);

    this.timeline.addTween(cjs.Tween.get(this.shape_1).wait(1));

    // veil
    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('rgba(255,255,255,0.498)')
      .s()
      .p('Eg+fAu4MAAAhdvMB8/AAAMAAABdvg');
    this.shape_2.setTransform(400, 300);

    this.timeline.addTween(cjs.Tween.get(this.shape_2).wait(1));

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.PracticeMenu,
    new cjs.Rectangle(0, 0, 800, 600),
    null,
  );

  (lib.comsuntexsymbolsGameFrame = function (
    mode,
    startPosition,
    loop,
    reversed,
  ) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // veil
    this.veil = new lib.GameFrame_veil();
    this.veil.name = 'veil';
    this.veil.setTransform(400, 300, 1, 1, 0, 0, 0, 400, 300);

    this.timeline.addTween(cjs.Tween.get(this.veil).wait(1));

    // changeRoundBtn
    this.changeRoundBtn = new lib.Scoreboard_changeRoundBtn();
    this.changeRoundBtn.name = 'changeRoundBtn';
    this.changeRoundBtn.setTransform(672.3, 578.8);

    this.timeline.addTween(cjs.Tween.get(this.changeRoundBtn).wait(1));

    // scoreboard
    this.scoreboard = new lib.comsuntexsymbolsScoreboard();
    this.scoreboard.name = 'scoreboard';
    this.scoreboard.setTransform(355.1, 573, 1, 1, 0, 0, 0, 355.1, 13);

    this.timeline.addTween(cjs.Tween.get(this.scoreboard).wait(1));

    // practiceMenu
    this.practiceMenu = new lib.PracticeMenu();
    this.practiceMenu.name = 'practiceMenu';
    this.practiceMenu.setTransform(400, 300, 1, 1, 0, 0, 0, 400, 300);

    this.timeline.addTween(cjs.Tween.get(this.practiceMenu).wait(1));

    // endScreen
    this.endScreen = new lib.EndScreen();
    this.endScreen.name = 'endScreen';
    this.endScreen.setTransform(400, 300, 1, 1, 0, 0, 0, 400, 300);

    this.timeline.addTween(cjs.Tween.get(this.endScreen).wait(1));

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.comsuntexsymbolsGameFrame,
    new cjs.Rectangle(-5, -5, 810, 610),
    null,
  );

  (lib.TestWindow = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = { current: 0 };
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    this.isSingleFrame = false;
    // timeline functions:
    this.frame_0 = function () {
      if (this.isSingleFrame) {
        return;
      }
      if (this.totalFrames == 1) {
        this.isSingleFrame = true;
      }
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(1));

    // current
    this.row3col3 = new lib.numberPanel();
    this.row3col3.name = 'row3col3';
    this.row3col3.setTransform(495.1, 401.35, 1.35, 1.3182, 0, 0, 0, 17.1, 13);

    this.row3col2 = new lib.numberPanel();
    this.row3col2.name = 'row3col2';
    this.row3col2.setTransform(355.1, 401.35, 1.35, 1.3182, 0, 0, 0, 17.1, 13);

    this.row3col1 = new lib.numberPanel();
    this.row3col1.name = 'row3col1';
    this.row3col1.setTransform(215.1, 401.35, 1.35, 1.3182, 0, 0, 0, 17.1, 13);

    this.row3col0 = new lib.numberPanel();
    this.row3col0.name = 'row3col0';
    this.row3col0.setTransform(75.1, 401.35, 1.35, 1.3182, 0, 0, 0, 17.1, 13);

    this.row2col0 = new lib.numberPanel();
    this.row2col0.name = 'row2col0';
    this.row2col0.setTransform(75.1, 266.35, 1.35, 1.3182, 0, 0, 0, 17.1, 13);

    this.row2col3 = new lib.numberPanel();
    this.row2col3.name = 'row2col3';
    this.row2col3.setTransform(495.1, 266.35, 1.35, 1.3182, 0, 0, 0, 17.1, 13);

    this.row2col2 = new lib.numberPanel();
    this.row2col2.name = 'row2col2';
    this.row2col2.setTransform(355.1, 266.35, 1.35, 1.3182, 0, 0, 0, 17.1, 13);

    this.row2col1 = new lib.numberPanel();
    this.row2col1.name = 'row2col1';
    this.row2col1.setTransform(215.1, 266.35, 1.35, 1.3182, 0, 0, 0, 17.1, 13);

    this.row1col3 = new lib.numberPanel();
    this.row1col3.name = 'row1col3';
    this.row1col3.setTransform(495.1, 131.35, 1.35, 1.3182, 0, 0, 0, 17.1, 13);

    this.row1col2 = new lib.numberPanel();
    this.row1col2.name = 'row1col2';
    this.row1col2.setTransform(355.1, 131.35, 1.35, 1.3182, 0, 0, 0, 17.1, 13);

    this.row1col1 = new lib.numberPanel();
    this.row1col1.name = 'row1col1';
    this.row1col1.setTransform(215.1, 131.35, 1.35, 1.3182, 0, 0, 0, 17.1, 13);

    this.row1col0 = new lib.numberPanel();
    this.row1col0.name = 'row1col0';
    this.row1col0.setTransform(75.1, 131.35, 1.35, 1.3182, 0, 0, 0, 17.1, 13);

    this.row0col3 = new lib.numberPanel();
    this.row0col3.name = 'row0col3';
    this.row0col3.setTransform(495.1, -4.05, 1.3504, 1.3182, 0, 0, 0, 17.1, 13);

    this.row0col2 = new lib.numberPanel();
    this.row0col2.name = 'row0col2';
    this.row0col2.setTransform(355.1, -4.05, 1.3504, 1.3182, 0, 0, 0, 17.1, 13);

    this.row0col1 = new lib.numberPanel();
    this.row0col1.name = 'row0col1';
    this.row0col1.setTransform(215.1, -4.05, 1.3504, 1.3182, 0, 0, 0, 17.1, 13);

    this.row0col0 = new lib.numberPanel();
    this.row0col0.name = 'row0col0';
    this.row0col0.setTransform(75.1, -4.05, 1.3504, 1.3182, 0, 0, 0, 17.1, 13);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.row0col0 },
            { t: this.row0col1 },
            { t: this.row0col2 },
            { t: this.row0col3 },
            { t: this.row1col0 },
            { t: this.row1col1 },
            { t: this.row1col2 },
            { t: this.row1col3 },
            { t: this.row2col1 },
            { t: this.row2col2 },
            { t: this.row2col3 },
            { t: this.row2col0 },
            { t: this.row3col0 },
            { t: this.row3col1 },
            { t: this.row3col2 },
            { t: this.row3col3 },
          ],
        })
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.TestWindow,
    new cjs.Rectangle(19.5, -58.1, 559.9, 538.5),
    null,
  );

  (lib.GameStage = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // stuff...
    this.mPiece = new lib.mPiece();
    this.mPiece.name = 'mPiece';
    this.mPiece.setTransform(145.1, -41.95, 1, 1, 0, 0, 0, 23.2, 25.9);

    this.roundMeter = new lib.verticalMeter();
    this.roundMeter.name = 'roundMeter';
    this.roundMeter.setTransform(659.95, 241.9, 1, 0.71, 0, 0, 0, 30.7, -21);

    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#000000')
      .s()
      .p(
        'AgaAlQgHgJAAgQQAAgIACgGQACgGAFgFQAEgFAFgCQAGgCAGAAIAIABIAIADIAAgcIAVAAIAABaIgVAAIAAgGQgFAEgFACQgEADgGAAQgMAAgHgKgAgIgCQgEAFAAAJQAAAKAEAEQADAEAGABIAGgCIAGgDIAAgfIgFgBIgEAAQgHAAgFAEg',
      );
    this.shape.setTransform(662.375, 234.45);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#000000')
      .s()
      .p(
        'AAMAiIAAghIgBgHIgBgGQAAAAgBgBQAAAAAAAAQgBgBAAAAQgBgBAAAAIgGgBIgGABIgGADIAAAuIgVAAIAAhBIAVAAIAAAHQAFgEAGgDQAEgCAHAAQAKAAAGAGQAGAHAAAMIAAAqg',
      );
    this.shape_1.setTransform(654.15, 235.525);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#000000')
      .s()
      .p(
        'AgaAbQgGgFAAgNIAAgqIAVAAIAAAhIAAAHQABAEABACQAAAAABABQAAAAAAABQABAAAAAAQABABABAAIAFABIAGgBIAGgDIAAguIAVAAIAABBIgVAAIAAgIIgLAIQgDACgIAAQgLAAgFgHg',
      );
    this.shape_2.setTransform(645.55, 235.7);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#000000')
      .s()
      .p(
        'AgZAZQgKgJAAgQQAAgPAKgKQAJgJAQAAQASAAAJAJQAJAKAAAPQAAAQgJAJQgJAKgSAAQgQAAgJgKgAgEgTIgFAEIgDAGIgBAJIABAJQABAEACADIAEADIAGACIAFgCIAEgDIADgGIACgKIgCgJQgBgDgCgCQgCgDgCgBIgGgBIgEAAg',
      );
    this.shape_3.setTransform(637.15, 235.6);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .f('#000000')
      .s()
      .p(
        'AgXAhIAAhBIAVAAIAAAKQAGgGAFgCQAGgCAEAAIACAAIADAAIAAAVIgCAAIgEgBIgFAAIgIAAIgHACIAAArg',
      );
    this.shape_4.setTransform(630.475, 235.6);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f('#000000')
      .s()
      .p(
        'AgXAaQgLgJAAgRQAAgPAKgKQAKgJARAAQAPAAAJAIQAIAJAAAPIAAAGIgwAAQABAHAGAFQAFAEAKAAQAGAAAGgDIAKgEIACAAIAAARIgNADQgHACgHAAQgTAAgKgJgAgIgSQgEADgBAHIAbAAQAAgGgDgEQgDgCgHAAQgGAAgDACg',
      );
    this.shape_5.setTransform(716.5, 235.6);

    this.shape_6 = new cjs.Shape();
    this.shape_6.graphics
      .f('#000000')
      .s()
      .p(
        'AAhAiIAAghIgBgHIgBgGQAAAAAAgBQgBAAAAAAQgBgBAAAAQgBgBAAAAIgGgBIgFABIgHADIAAAuIgUAAIAAghIAAgHIgBgGIgDgDIgGgBIgGABIgGADIAAAuIgVAAIAAhBIAVAAIAAAHQAGgEAFgCQAFgDAGAAQAGAAAEADQAFADADAGQAGgGAGgDQAGgDAGAAQALAAAFAHQAGAGAAAMIAAAqg',
      );
    this.shape_6.setTransform(706.225, 235.525);

    this.shape_7 = new cjs.Shape();
    this.shape_7.graphics
      .f('#000000')
      .s()
      .p(
        'AgZAdQgHgGAAgJQAAgHAEgFQADgDAGgDQAGgDAIgBIARgBIAAgBQAAgFgEgCQgFgCgHAAIgMABIgIADIgCAAIAAgQIALgCIAPgBQARAAAIAGQAIAFAAAMIAAAsIgVAAIAAgHIgEADIgFADIgFACIgIABQgJAAgGgGgAADADIgHABIgFADQgBACAAADIAAADQAAABAAAAQAAAAABABQAAAAAAAAQAAABABAAIADACIAFAAQADAAADgBIAGgDIAAgOIgJABg',
      );
    this.shape_7.setTransform(695.625, 235.625);

    this.shape_8 = new cjs.Shape();
    this.shape_8.graphics
      .f('#000000')
      .s()
      .p(
        'AgPAtIgLgCIAAgQIACAAIAKADIAJABIAJgBQAEgBACgCIACgFIABgHIAAgBQgEADgEABQgFACgFAAQgNAAgIgIQgHgIAAgQQAAgIACgGQACgGAEgFQAEgEAGgCQAFgCAGAAIAJABIAIADIABgDIAUAAIAAA6QAAAJgCAGQgDAHgFADQgFAEgGABQgHACgHAAIgOgBgAgIgZQgEAFAAAIQAAAKAEACQADAEAGAAIAGgBIAGgCIAAgdIgEgBIgFgBQgHAAgFAFg',
      );
    this.shape_8.setTransform(687.425, 236.775);

    this.gameMeter = new lib.verticalMeter();
    this.gameMeter.name = 'gameMeter';
    this.gameMeter.setTransform(717.95, 241.9, 1, 0.71, 0, 0, 0, 30.7, -21);

    this.opBtn1 = new lib.OperationButtons();
    this.opBtn1.name = 'opBtn1';
    this.opBtn1.setTransform(676.75, 80.2, 1.5, 1.5, 0, 0, 0, 0, -0.2);

    this.testWindow = new lib.TestWindow();
    this.testWindow.name = 'testWindow';
    this.testWindow.setTransform(160.35, 199.4, 1, 1, 0, 0, 0, 170.8, 130.1);

    this.startButton = new lib.start();
    this.startButton.name = 'startButton';
    this.startButton.setTransform(600.2, 616.45, 1, 1, 0, 0, 0, 39.2, 18.2);

    this.blocker = new lib.blocker();
    this.blocker.name = 'blocker';
    this.blocker.setTransform(217.5, 236.75, 3.0072, 3.7325, 0, 0, 0, 69, 57);

    this.shape_9 = new cjs.Shape();
    this.shape_9.graphics
      .f('#7AA8F9')
      .s()
      .p('EgJhAp7QhBgBAAhAMAAAhRzQAAhBBBABITDAAQBBgBAABBMAAABRzQAABAhBABg');
    this.shape_9.setTransform(676.75, 280.1);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.shape_9 },
            { t: this.blocker },
            { t: this.startButton },
            { t: this.testWindow },
            { t: this.opBtn1 },
            { t: this.gameMeter },
            { t: this.shape_8 },
            { t: this.shape_7 },
            { t: this.shape_6 },
            { t: this.shape_5 },
            { t: this.shape_4 },
            { t: this.shape_3 },
            { t: this.shape_2 },
            { t: this.shape_1 },
            { t: this.shape },
            { t: this.roundMeter },
            { t: this.mPiece },
          ],
        })
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.GameStage,
    new cjs.Rectangle(9.1, -95.8, 735.1999999999999, 645.5),
    null,
  );

  // stage content:
  (lib.VIFMulDiv = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // gameFrame
    this.gameFrame = new lib.comsuntexsymbolsGameFrame();
    this.gameFrame.name = 'gameFrame';
    this.gameFrame.setTransform(400, 300, 1, 1, 0, 0, 0, 400, 300);

    this.timeline.addTween(cjs.Tween.get(this.gameFrame).wait(1));

    // gameStage
    this.gameStage = new lib.GameStage();
    this.gameStage.name = 'gameStage';
    this.gameStage.setTransform(396, 273.8, 1, 1, 0, 0, 0, 396, 273.8);

    this.timeline.addTween(cjs.Tween.get(this.gameStage).wait(1));

    // bg
    this.background = new lib.Background();
    this.background.name = 'background';
    this.background.setTransform(-70.95, 312.4, 1, 1, 0, 0, 0, 400, 300.4);

    this.timeline.addTween(cjs.Tween.get(this.background).wait(1));

    this._renderFirstFrame();
  }).prototype = p = new lib.AnMovieClip();
  p.nominalBounds = new cjs.Rectangle(395, 204.2, 410, 400.8);
  // library properties:
  lib.properties = {
    id: 'D011E3B725D3BB4087B7DA993BA7A524',
    width: 800,
    height: 600,
    fps: 24,
    color: '#FFFFFF',
    opacity: 1.0,
    manifest: [],
    preloads: [],
  };

  // bootstrap callback support:

  (lib.Stage = function (canvas) {
    createjs.Stage.call(this, canvas);
  }).prototype = p = new createjs.Stage();

  p.setAutoPlay = function (autoPlay) {
    this.tickEnabled = autoPlay;
  };
  p.play = function () {
    this.tickEnabled = true;
    this.getChildAt(0).gotoAndPlay(this.getTimelinePosition());
  };
  p.stop = function (ms) {
    if (ms) this.seek(ms);
    this.tickEnabled = false;
  };
  p.seek = function (ms) {
    this.tickEnabled = true;
    this.getChildAt(0).gotoAndStop((lib.properties.fps * ms) / 1000);
  };
  p.getDuration = function () {
    return (this.getChildAt(0).totalFrames / lib.properties.fps) * 1000;
  };

  p.getTimelinePosition = function () {
    return (this.getChildAt(0).currentFrame / lib.properties.fps) * 1000;
  };

  an.bootcompsLoaded = an.bootcompsLoaded || [];
  if (!an.bootstrapListeners) {
    an.bootstrapListeners = [];
  }

  an.bootstrapCallback = function (fnCallback) {
    an.bootstrapListeners.push(fnCallback);
    if (an.bootcompsLoaded.length > 0) {
      for (var i = 0; i < an.bootcompsLoaded.length; ++i) {
        fnCallback(an.bootcompsLoaded[i]);
      }
    }
  };

  an.compositions = an.compositions || {};
  an.compositions['D011E3B725D3BB4087B7DA993BA7A524'] = {
    getStage: function () {
      return exportRoot.stage;
    },
    getLibrary: function () {
      return lib;
    },
    getSpriteSheet: function () {
      return ss;
    },
    getImages: function () {
      return img;
    },
  };

  an.compositionLoaded = function (id) {
    an.bootcompsLoaded.push(id);
    for (var j = 0; j < an.bootstrapListeners.length; j++) {
      an.bootstrapListeners[j](id);
    }
  };

  an.getComposition = function (id) {
    return an.compositions[id];
  };

  an.makeResponsive = function (
    isResp,
    respDim,
    isScale,
    scaleType,
    domContainers,
    stage,
  ) {
    var lastW,
      lastH,
      lastS = 1;
    window.addEventListener('resize', resizeCanvas);
    resizeCanvas();
    function resizeCanvas() {
      var w = lib.properties.width,
        h = lib.properties.height;
      var iw = window.innerWidth,
        ih = window.innerHeight;
      var pRatio = window.devicePixelRatio || 1,
        xRatio = iw / w,
        yRatio = ih / h,
        sRatio = 1;
      if (isResp) {
        if (
          (respDim == 'width' && lastW == iw) ||
          (respDim == 'height' && lastH == ih)
        ) {
          sRatio = lastS;
        } else if (!isScale) {
          if (iw < w || ih < h) sRatio = Math.min(xRatio, yRatio);
        } else if (scaleType == 1) {
          sRatio = Math.min(xRatio, yRatio);
        } else if (scaleType == 2) {
          sRatio = Math.max(xRatio, yRatio);
        }
      }
      domContainers[0].width = w * pRatio * sRatio;
      domContainers[0].height = h * pRatio * sRatio;
      domContainers.forEach(function (container) {
        container.style.width = w * sRatio + 'px';
        container.style.height = h * sRatio + 'px';
      });
      stage.scaleX = pRatio * sRatio;
      stage.scaleY = pRatio * sRatio;
      lastW = iw;
      lastH = ih;
      lastS = sRatio;
      stage.tickOnUpdate = false;
      stage.update();
      stage.tickOnUpdate = true;
    }
  };
  an.handleSoundStreamOnTick = function (event) {
    if (!event.paused) {
      var stageChild = stage.getChildAt(0);
      if (!stageChild.paused || stageChild.ignorePause) {
        stageChild.syncStreamSounds();
      }
    }
  };
  an.handleFilterCache = function (event) {
    if (!event.paused) {
      var target = event.target;
      if (target) {
        if (target.filterCacheList) {
          for (var index = 0; index < target.filterCacheList.length; index++) {
            var cacheInst = target.filterCacheList[index];
            if (
              cacheInst.startFrame <= target.currentFrame &&
              target.currentFrame <= cacheInst.endFrame
            ) {
              cacheInst.instance.cache(
                cacheInst.x,
                cacheInst.y,
                cacheInst.w,
                cacheInst.h,
              );
            }
          }
        }
      }
    }
  };
}
